(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1047],{

/***/ 2067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ActionWidget; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _lib_api_apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7050);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5944);



function ActionWidget(_ref) {
  var action = _ref.action;
  var widget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (widget.current && action.widget_script) {
      widget.current.innerHTML = action.widget_script.split(';').join('');
      var script = document.createElement('script');
      script.setAttribute('src', _lib_api_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .TEPLOHOD_SCRIPT_URL */ .Nv);
      document.head.appendChild(script);
    }
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    ref: widget
  });
}

/***/ }),

/***/ 5685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(1463);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./lib/api/http.js
var http = __webpack_require__(1377);
// EXTERNAL MODULE: ./lib/api/urls.ts
var urls = __webpack_require__(4154);
// EXTERNAL MODULE: ./constants/events.ts
var events = __webpack_require__(6880);
// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(902);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(7135);
// EXTERNAL MODULE: ./lib/consts.ts
var consts = __webpack_require__(9006);
// EXTERNAL MODULE: ./components/blocks/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(9013);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(120);
// EXTERNAL MODULE: ./node_modules/react-timer-hook/dist/index.js
var dist = __webpack_require__(3751);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./public/img/redRouble.svg
var redRouble = __webpack_require__(5629);
// EXTERNAL MODULE: ./public/img/calendar.svg
var calendar = __webpack_require__(7393);
;// CONCATENATED MODULE: ./public/img/duration.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDuration = function SvgDuration(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M180.6 75.4c-13.9-14-32.8-21.8-52.6-21.8V128l-52.6 52.6c29 29 76.1 29 105.3 0 29-29 29-76 0-105-.1-.1-.1-.1-.1-.2zM128 4C59.6 4 4 59.6 4 128s55.6 124 124 124 124-55.6 124-124S196.4 4 128 4zm0 223.2c-54.8 0-99.2-44.4-99.2-99.2S73.2 28.8 128 28.8s99.2 44.4 99.2 99.2-44.4 99.2-99.2 99.2z"
  })));
};
/* harmony default export */ var duration = (SvgDuration);
// EXTERNAL MODULE: ./public/img/location.svg
var img_location = __webpack_require__(1271);
// EXTERNAL MODULE: ./components/styled/Link.tsx
var Link = __webpack_require__(6196);
// EXTERNAL MODULE: ./utils/event.js
var utils_event = __webpack_require__(923);
// EXTERNAL MODULE: ./utils/index.tsx
var utils = __webpack_require__(6535);
// EXTERNAL MODULE: ./providers/modal.tsx
var modal = __webpack_require__(6147);
// EXTERNAL MODULE: ./components/ya-map/YaMapModal.tsx + 1 modules
var YaMapModal = __webpack_require__(1174);
// EXTERNAL MODULE: ./models/action.ts
var models_action = __webpack_require__(193);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/blocks/AsideEventBlock.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var _ref4 =  true ? {
  name: "1j180j4",
  styles: "width:100%;margin-bottom:12px"
} : 0;

var _ref5 =  true ? {
  name: "lnhig8",
  styles: "font-size:14px;font-family:Golos"
} : 0;

var _ref6 =  true ? {
  name: "jtgj4i",
  styles: "color:#F44336"
} : 0;

var _ref7 =  true ? {
  name: "zt7uw9",
  styles: "width:100%;height:4px;background:#7D7B7A;border-radius:2px;margin-top:5px;overflow:hidden"
} : 0;

var _ref8 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref9 =  true ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : 0;

var _ref10 =  true ? {
  name: "1cjitc6",
  styles: "width:16px"
} : 0;

var _ref11 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref12 =  true ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : 0;

var _ref13 =  true ? {
  name: "1cjitc6",
  styles: "width:16px"
} : 0;

var _ref14 =  true ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : 0;

var _ref15 =  true ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : 0;

var _ref18 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref19 =  true ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : 0;

var _ref20 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref21 =  true ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : 0;

var _ref22 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref23 =  true ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : 0;

var _ref24 =  true ? {
  name: "1c3pogw",
  styles: "display:flex;flex-direction:column;gap:10px"
} : 0;

var _ref25 =  true ? {
  name: "yzv23",
  styles: "display:flex;flex-direction:column;align-items:flex-start;gap:4px"
} : 0;

var _ref26 =  true ? {
  name: "1l4ndn6",
  styles: "line-height:20px"
} : 0;

function AsideEventBlock(_ref) {
  var item = _ref.item,
      currentCity = _ref.currentCity;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();

  var _useState = (0,react.useState)(0),
      progressValue = _useState[0],
      setProgressValue = _useState[1];

  var modalState = (0,modal/* useModal */.dd)();

  var _useState2 = (0,react.useState)({
    showTimer: false,
    startDate: null,
    endDate: null,
    title: null
  }),
      timerData = _useState2[0],
      setTimerData = _useState2[1];

  var _useTimer = (0,dist.useTimer)({
    expiryTimestamp: timerData.endDate ? luxon/* DateTime.fromISO */.ou.fromISO(timerData.endDate).valueOf() : new Date().valueOf(),
    onExpire: function onExpire() {
      return console.warn('onExpire called');
    }
  }),
      seconds = _useTimer.seconds,
      minutes = _useTimer.minutes,
      hours = _useTimer.hours,
      days = _useTimer.days,
      restart = _useTimer.restart;

  function getMicroDataDate(fieldName, isDateUnknown) {
    if (isDateUnknown) {
      return luxon/* DateTime.now */.ou.now().toISO();
    }

    if (fieldName === 'startDate' && item.nearest_event) {
      return luxon/* DateTime.fromFormat */.ou.fromFormat(item.nearest_event.time.length > 0 ? [item.nearest_event.start_date, item.nearest_event.time[0]].join(' ') : item.nearest_event.start_date, item.nearest_event.time.length > 0 ? 'yyyy-LL-dd HH:mm:ss' : 'yyyy-LL-dd').toISO();
    }

    if (fieldName === 'endDate' && item.latest_event) {
      return luxon/* DateTime.fromFormat */.ou.fromFormat(item.latest_event.time.length > 0 ? [item.latest_event.start_date, item.latest_event.time[0]].join(' ') : item.latest_event.start_date, item.latest_event.time.length > 0 ? 'yyyy-LL-dd HH:mm:ss' : 'yyyy-LL-dd').toISO();
    }

    return luxon/* DateTime.now */.ou.now().toISO();
  }

  (0,react.useEffect)(function () {
    var newTimerData = {
      showTimer: false,
      startDate: null,
      endDate: null,
      title: (0,utils/* getTitleForTimer */.KR)(item.countdown_type)
    };
    var dataPrepareForTimer = null;
    var dateList = (0,utils/* revealDate */.Vj)(item.dates.filter(function (_ref2) {
      var quotas = _ref2.quotas;
      if ((quotas === null || quotas === void 0 ? void 0 : quotas.length) === 0) return true;
      return quotas === null || quotas === void 0 ? void 0 : quotas.some(function (_ref3) {
        var quantity = _ref3.quantity;
        return quantity > 0;
      });
    }).map(function (date) {
      if (date.time.length > 0) {
        return {
          interval: "".concat(date.start_date, " - ").concat(date.end_date),
          time: date.time
        };
      } // if there is no time before the end date next day at midnight


      return {
        interval: "".concat(date.start_date, " - ").concat(luxon/* DateTime.fromFormat */.ou.fromFormat(date.end_date, 'yyyy-MM-dd').plus({
          days: 1
        }).toFormat('yyyy-MM-dd')),
        time: []
      };
    }));
    var dateListWithTz = dateList.map(function (dateItem) {
      var dateItemString = dateItem.toFormat('yyyy-MM-dd HH:mm:ss');
      return luxon/* DateTime.fromFormat */.ou.fromFormat(dateItemString, 'yyyy-MM-dd HH:mm:ss').setZone(currentCity.tz, {
        keepLocalTime: true
      }).setZone(luxon/* DateTime.local */.ou.local().toFormat('z'));
    });
    (0,utils/* countdownInit */.Gw)(item.countdown_type === 'manual' ? [luxon/* DateTime.fromISO */.ou.fromISO(item.countdown_datetime)] : dateListWithTz, item.countdown_type, function (countdown) {
      dataPrepareForTimer = countdown;
    });

    if (dataPrepareForTimer) {
      newTimerData.showTimer = true;
      newTimerData.endDate = moment_default()().valueOf() + dataPrepareForTimer.date;
      newTimerData.startDate = moment_default()(moment_default()().valueOf() + dataPrepareForTimer.date).subtract(7, 'day');
    }

    if (newTimerData.showTimer) {
      var a = (Number(moment_default()().valueOf()) - Number(newTimerData.startDate.valueOf())) * 100;
      var b = Number(moment_default()(newTimerData.endDate).valueOf()) - Number(newTimerData.startDate.valueOf());
      var newProgressVal = Math.round(a / b);
      setProgressValue(newProgressVal);
      restart(newTimerData.endDate);
    }

    setTimerData(newTimerData);
  }, [item]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
      backgroundColor: theme.colors.white,
      borderRadius: 4,
      padding: 30,
      marginBottom: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      fontFamily: 'Golos',
      gap: 8,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0em',
      color: '#333'
    }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
      padding: 20
    }),  true ? "" : 0,  true ? "" : 0),
    children: [timerData.showTimer && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: _ref4,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref5,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: timerData.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: "\xA0\xA0\xA0"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: _ref6,
          children: (0,utils/* formatTimerEvent */.dm)(days, hours, minutes, seconds)
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref7,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            height: '100%',
            width: "".concat(progressValue, "%"),
            background: '#F44336',
            borderRadius: 2,
            marginLeft: -1
          },  true ? "" : 0,  true ? "" : 0)
        })
      })]
    }), item.type !== models_action/* ACTION_TYPES.FREE */.aI.FREE && item.price && item.price !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      title: item.instead_price && item.filter_price ? "\u0412\u0430\u0448\u0430 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u044F ".concat((0,utils/* splitPriceByThree */.ax)((0,utils/* getBenefit */.yM)(item.instead_price, item.filter_price)), "\u20BD") : '',
      itemProp: "offers",
      itemScope: true,
      itemType: "https://schema.org/Offer",
      css: _ref8,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref9,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(redRouble/* default */.Z, {
          css: _ref10
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          dangerouslySetInnerHTML: {
            __html: item.price
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        itemProp: "price",
        content: "".concat(item.filter_price || '')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        itemProp: "priceCurrency",
        content: "RUB"
      })]
    }), item.type === models_action/* ACTION_TYPES.FREE */.aI.FREE && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: _ref11,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref12,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(redRouble/* default */.Z, {
          css: _ref13
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        display: 'flex',
        gap: 8,
        maxHeight: 280,
        overflow: 'auto',
        width: '100%',
        '&::-webkit-scrollbar': {
          width: 4,
          backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundImage: "-webkit-linear-gradient(90deg,\n            transparent,\n            rgba(0, 0, 0, 0) 0%,\n            rgba(244, 67, 54, 0.3) 10%,\n            rgba(244, 67, 54, 0.9) 20%,\n            rgba(244, 67, 54, 1) 50%,\n            rgba(244, 67, 54, 0.9) 80%,\n            rgba(244, 67, 54, 0.3) 90%,\n            rgba(0, 0, 0, 0) 100%,\n            transparent)"
        }
      },  true ? "" : 0,  true ? "" : 0),
      children: !(0,utils_event/* isEventPassed */.Bz)(item) && item.dates_txt_detailed.length > 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: _ref14,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar/* default */.Z, {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              width: 16,
              fill: theme.colors.red
            },  true ? "" : 0,  true ? "" : 0)
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: _ref15,
          dangerouslySetInnerHTML: {
            __html: item.dates_txt_detailed.map(function (date) {
              return Object.entries(date).map(function (_ref16) {
                var _ref17 = (0,slicedToArray/* default */.Z)(_ref16, 2),
                    month = _ref17[0],
                    datesDays = _ref17[1];

                var daysSeparator = month ? '<br/>' : ' и ';
                return [month, datesDays.join(daysSeparator)].filter(Boolean).join("<br/>");
              });
            }).join("<br/>")
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
          itemProp: "startDate",
          content: getMicroDataDate('startDate', false)
        }), item.with_open_date && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
          itemProp: "endDate",
          content: getMicroDataDate('endDate', false)
        })]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: _ref18,
        children: item.date_unknown && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _ref19,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar/* default */.Z, {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                width: 16,
                fill: theme.colors.red
              },  true ? "" : 0,  true ? "" : 0)
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            children: "\u0414\u0430\u0442\u0430 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            itemProp: "startDate",
            content: getMicroDataDate('startDate', true)
          }), item.with_open_date && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            itemProp: "endDate",
            content: getMicroDataDate('endDate', true)
          })]
        })
      })
    }), item.duration && item.duration !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: _ref20,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref21,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(duration, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            width: 16,
            fill: theme.colors.red
          },  true ? "" : 0,  true ? "" : 0)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        itemProp: "duration",
        children: item.duration
      })]
    }), item.places.length && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: _ref22,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref23,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(img_location/* default */.Z, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            width: 16,
            fill: theme.colors.red
          },  true ? "" : 0,  true ? "" : 0)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref24,
        children: item.places && item.places.length > 0 && item.places.map(function (place) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _ref25,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            , {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                fontFamily: 'Golos',
                fontSize: '14',
                fontWeight: 500,
                lineHeight: '20px',
                marginBottom: 10,
                display: 'inline-block',
                textDecoration: 'underline',
                textDecorationStyle: 'dashed',
                color: theme.colors.red,
                ':hover': {
                  color: theme.colors.red,
                  textDecorationStyle: 'solid'
                }
              },  true ? "" : 0,  true ? "" : 0),
              href: ['', 'places', place.slug, ''].join('/'),
              children: place.title
            }), place.addresses.map(function (address, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  itemProp: "location",
                  css: _ref26,
                  children: address
                }, address), place.coordinates_list[index] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                  css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                    fontFamily: 'Golos',
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: '20px',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    borderBottom: '1px dashed rgba(0, 0, 0, 0.5)',
                    color: theme.colors.black,
                    ':hover': {
                      borderBottom: '1px solid rgba(0, 0, 0, 0.5)'
                    }
                  },  true ? "" : 0,  true ? "" : 0),
                  type: "button",
                  onClick: function onClick() {
                    if (modalState) {
                      modalState.setModalState(function (oldState) {
                        return _objectSpread(_objectSpread({}, oldState), {}, {
                          show: true,
                          content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YaMapModal/* YaMapModal */.L, {
                            cords: place.coordinates_list[index],
                            setModalState: modalState.setModalState
                          }),
                          options: {
                            width: 800
                          }
                        });
                      });
                    }
                  },
                  children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430 \u043A\u0430\u0440\u0442\u0435"
                }, place.coordinates_list[index])]
              });
            })]
          }, place.title);
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./components/picture/picture.tsx
var picture = __webpack_require__(2786);
// EXTERNAL MODULE: ./public/img/views2.svg
var views2 = __webpack_require__(3148);
// EXTERNAL MODULE: ./public/img/star.svg
var star = __webpack_require__(6955);
;// CONCATENATED MODULE: ./public/img/check-mark.svg
var check_mark_path;
function check_mark_extends() { check_mark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_mark_extends.apply(this, arguments); }

var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/react.createElement("svg", check_mark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), check_mark_path || (check_mark_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 11.798 10.093 18 20 6",
    stroke: "#249608",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })));
};
/* harmony default export */ var check_mark = (SvgCheckMark);
// EXTERNAL MODULE: ./components/styled/typography.js
var typography = __webpack_require__(2068);
// EXTERNAL MODULE: ./components/favorite/FavoriteButton.tsx + 3 modules
var FavoriteButton = __webpack_require__(7344);
// EXTERNAL MODULE: ./components/favorite/FavoriteButtonWrapper.tsx
var FavoriteButtonWrapper = __webpack_require__(6198);
// EXTERNAL MODULE: ./models/favorite.ts
var favorite = __webpack_require__(494);
// EXTERNAL MODULE: ./components/styled/Button.tsx
var Button = __webpack_require__(7601);
// EXTERNAL MODULE: ./utils/word-declension.ts
var word_declension = __webpack_require__(420);
;// CONCATENATED MODULE: ./components/blocks/EventBanner.tsx



function EventBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EventBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EventBanner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EventBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function EventBanner_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















var _ref2 =  true ? {
  name: "1trc3r3",
  styles: "position:absolute;inset:0;height:100%;width:100%;object-fit:cover;z-index:1"
} : 0;

var _ref3 =  true ? {
  name: "xem8jb",
  styles: "width:73px;height:40px;background:rgba(125, 123, 122, 0.8);border-radius:0px 4px 4px 0px;font-family:Montserrat;font-size:16px;line-height:22px;font-weight:500;display:flex;justify-content:center;align-items:center;position:absolute;left:0"
} : 0;

var EventBanner_ref4 =  true ? {
  name: "5ej25d",
  styles: "display:flex;justify-content:flex-end;align-items:center"
} : 0;

var EventBanner_ref5 =  true ? {
  name: "1jvurm9",
  styles: "display:flex;align-items:center;gap:5px"
} : 0;

var EventBanner_ref6 =  true ? {
  name: "1cq4wtb",
  styles: "width:20px;height:18px"
} : 0;

var EventBanner_ref7 =  true ? {
  name: "9cwnik",
  styles: "display:flex;flex-basis:50%;flex-direction:column;gap:5px"
} : 0;

var EventBanner_ref8 =  true ? {
  name: "eq7f8j",
  styles: "display:flex;align-items:flex-end"
} : 0;

var EventBanner_ref9 =  true ? {
  name: "12ubb9t",
  styles: "width:16px;height:16px;color:#FFC907"
} : 0;

var EventBanner_ref10 =  true ? {
  name: "13f77hx",
  styles: "font-family:Montserrat;font-size:18px;line-height:14px;font-weight:bold;margin:0 8px"
} : 0;

var EventBanner_ref11 =  true ? {
  name: "11nilye",
  styles: "font-size:12px;text-decoration:underline dashed;line-height:14px;:hover{text-decoration:none;}"
} : 0;

var EventBanner_ref12 =  true ? {
  name: "1jjdfim",
  styles: "vertical-align:middle;font-family:Montserrat;font-size:18px;line-height:25px;color:white;font-weight:bold"
} : 0;

var EventBanner_ref13 =  true ? {
  name: "14ci5dx",
  styles: "text-decoration:red line-through;margin-right:5px"
} : 0;

var EventBanner_ref14 =  true ? {
  name: "9y0jis",
  styles: "font-size:32px;line-height:32px;color:red"
} : 0;

var EventBanner_ref15 =  true ? {
  name: "1thcph1",
  styles: "font-size:32px;line-height:32px"
} : 0;

var _ref16 =  true ? {
  name: "ib1pfa",
  styles: "width:16px;height:14px"
} : 0;

var _ref17 =  true ? {
  name: "1jvurm9",
  styles: "display:flex;align-items:center;gap:5px"
} : 0;

var EventBanner_ref18 =  true ? {
  name: "1cq4wtb",
  styles: "width:20px;height:18px"
} : 0;

function EventBanner(_ref) {
  var _css2, _css3, _css6, _css8, _css9;

  var item = _ref.item,
      disabled = _ref.disabled,
      onButtonClick = _ref.onButtonClick,
      isRanOutOfTickets = _ref.isRanOutOfTickets,
      tsNextWidgetConfig = _ref.tsNextWidgetConfig;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();

  var getReview = function getReview(count) {
    return "".concat(count, " ").concat((0,word_declension/* default */.Z)(count, 'отзыв', 'отзыва', 'отзывов'));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css2 = {
      position: 'relative',
      width: '100%',
      height: 400,
      overflow: 'hidden',
      paddingBottom: 30
    }, (0,defineProperty/* default */.Z)(_css2, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
      marginBottom: 10
    }), (0,defineProperty/* default */.Z)(_css2, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
      marginBottom: -20
    }), _css2),  true ? "" : 0,  true ? "" : 0),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(picture/* Image */.Ee, {
      css: _ref2,
      loading: "eager",
      image: item.images[0],
      alt: item.title
    }, item.id), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css3 = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'absolute',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        zIndex: 2,
        padding: '35px 20px 40px'
      }, (0,defineProperty/* default */.Z)(_css3, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
        padding: 20
      }), (0,defineProperty/* default */.Z)(_css3, "color", theme.colors.white), (0,defineProperty/* default */.Z)(_css3, "background", 'linear-gradient(180deg, rgba(19, 19, 19, 0) 25.52%, #131313 100%)'), _css3),  true ? "" : 0,  true ? "" : 0),
      children: [disabled && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref3,
        children: "\u0410\u0440\u0445\u0438\u0432"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: EventBanner_ref4,
        children: [!!item.discount && !disabled && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            position: 'absolute',
            top: 35,
            left: 0,
            backgroundColor: 'rgba(244, 67, 54, 0.8)',
            boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '0 4px 4px 0',
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: 16,
            textAlign: 'center',
            padding: 10
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            padding: 8,
            fontSize: 14,
            top: 20
          }),  true ? "" : 0,  true ? "" : 0),
          children: ["\u2212", item.discount, "% \u0441\u043A\u0438\u0434\u043A\u0430"]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            display: 'flex',
            alignItems: 'center',
            gap: 16
          }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'none'
          }),  true ? "" : 0,  true ? "" : 0),
          children: [!!item.views && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: EventBanner_ref5,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(views2/* default */.Z, {
              css: EventBanner_ref6
            }), " ", item.views]
          }), !!item.age_category && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: item.age_category
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css6 = {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end'
        }, (0,defineProperty/* default */.Z)(_css6, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
          flexDirection: 'column',
          alignItems: 'unset',
          gap: 10
        }), (0,defineProperty/* default */.Z)(_css6, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          marginBottom: 20
        }), _css6),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: EventBanner_ref7,
          children: [item.status === events/* activeStatus */.cT && isRanOutOfTickets && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              width: 170,
              height: 40,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '5px 5px 5px 0',
              fontFamily: 'Golos, serif',
              fontSize: 14,
              color: theme.colors.white,
              backgroundColor: '#7D7B7A'
            }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
              order: 1,
              width: '100%'
            }),  true ? "" : 0,  true ? "" : 0),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: "\u0411\u0438\u043B\u0435\u0442\u044B \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0438\u0441\u044C"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: EventBanner_ref8,
            children: [item.comments_avg_rating > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(star/* default */.Z, {
                css: EventBanner_ref9
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: EventBanner_ref10,
                children: item.comments_avg_rating.toFixed(1)
              })]
            }), item.comments_count > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
              onClick: function onClick() {
                var el = document.querySelector('.comments-block');

                if (el) {
                  el.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              },
              type: "button",
              css: EventBanner_ref11,
              children: getReview(item.comments_count)
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H1, {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css8 = {
              color: '#F8F8F8',
              fontFamily: 'Montserrat',
              letterSpacing: '0.01em',
              lineHeight: '38px'
            }, (0,defineProperty/* default */.Z)(_css8, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
              fontSize: 32
            }), (0,defineProperty/* default */.Z)(_css8, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              fontSize: 22,
              lineHeight: '26px',
              padding: 0,
              marginBottom: 10
            }), _css8),  true ? "" : 0,  true ? "" : 0),
            children: item.title
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css9 = {
            display: 'flex',
            alignItems: 'center',
            gap: 10
          }, (0,defineProperty/* default */.Z)(_css9, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
            marginLeft: 'auto'
          }), (0,defineProperty/* default */.Z)(_css9, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            marginLeft: 0
          }), _css9),  true ? "" : 0,  true ? "" : 0),
          children: [item.type !== 'FREE' && item.display_price && !isRanOutOfTickets && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: EventBanner_ref12,
            children: [!!item.instead_price && item.instead_price > 0 && item.filter_price ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
              title: item.instead_price && item.filter_price ? "\u0412\u0430\u0448\u0430 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u044F ".concat((0,utils/* splitPriceByThree */.ax)((0,utils/* getBenefit */.yM)(item.instead_price, item.filter_price)), "\u20BD") : '',
              children: [item.display_price.indexOf('от') !== -1 ? 'от ' : '', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: EventBanner_ref13,
                children: (0,utils/* splitPriceByThree */.ax)(item.instead_price)
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                css: EventBanner_ref14,
                children: [(0,utils/* splitPriceByThree */.ax)(item.filter_price), "\u20BD"]
              })]
            }) : '', !item.instead_price && item.filter_price ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
              css: EventBanner_ref15,
              children: [item.display_price.indexOf('от') !== -1 ? 'от ' : '', (0,utils/* splitPriceByThree */.ax)(item.filter_price), "\u20BD"]
            }) : '']
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({}, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              display: 'none'
            }),  true ? "" : 0,  true ? "" : 0),
            children: !(0,utils_event/* isEventPassed */.Bz)(item) && item.dates_txt && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* RedButton */.QT, EventBanner_objectSpread(EventBanner_objectSpread({
              disabled: disabled,
              montserrat: true,
              callback: function callback() {
                onButtonClick();
              },
              subscription_confirmed: item.status === events/* activeStatus */.cT && item.subscription_confirmed
            }, tsNextWidgetConfig && {
              'data-type': tsNextWidgetConfig.type,
              'data-uid': tsNextWidgetConfig.id,
              className: 'tsnext-widget'
            }), {}, {
              children: [item.status === events/* activeStatus */.cT && item.subscription_confirmed && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(check_mark, {
                css: _ref16
              }), (0,utils_event/* getBuyButtonText */.A)(item, isRanOutOfTickets)]
            }))
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FavoriteButtonWrapper/* default */.Z, {
            actionShip: true,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FavoriteButton/* default */.Z, {
              kind: favorite/* FavoriteKinds.event */.f.event,
              id: item.remote_id,
              size: "medium",
              variant: "red-outline",
              actionShip: true
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            display: 'none',
            marginTop: 10
          }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            display: 'flex',
            justifyContent: 'space-between'
          }),  true ? "" : 0,  true ? "" : 0),
          children: [!!item.views && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _ref17,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(views2/* default */.Z, {
              css: EventBanner_ref18
            }), " ", item.views]
          }), item.age_category && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: item.age_category
          })]
        })]
      })]
    })]
  });
}
// EXTERNAL MODULE: ./components/blocks/ShareBlock.tsx
var ShareBlock = __webpack_require__(2863);
;// CONCATENATED MODULE: ./public/img/advantages/service_free.svg
var _circle, service_free_path;
function service_free_extends() { service_free_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return service_free_extends.apply(this, arguments); }

var SvgServiceFree = function SvgServiceFree(props) {
  return /*#__PURE__*/react.createElement("svg", service_free_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), service_free_path || (service_free_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.9 16.1c-.34 0-.663-.057-.97-.17a1.888 1.888 0 0 1-.79-.58c-.226-.28-.406-.65-.54-1.11-.133-.467-.2-1.047-.2-1.74v-.2c0-.647.067-1.187.2-1.62.134-.433.314-.78.54-1.04.227-.267.49-.457.79-.57.307-.113.63-.17.97-.17.34 0 .66.057.96.17.307.113.574.303.8.57.227.26.407.607.54 1.04.134.433.2.973.2 1.62v.2c0 .693-.066 1.273-.2 1.74-.133.46-.313.83-.54 1.11a1.876 1.876 0 0 1-.8.58c-.3.113-.62.17-.96.17Zm0-.82a1.6 1.6 0 0 0 .59-.11c.194-.08.36-.22.5-.42.147-.207.26-.49.34-.85.087-.36.13-.827.13-1.4v-.2c0-.52-.043-.947-.13-1.28-.08-.333-.193-.597-.34-.79a1.098 1.098 0 0 0-.5-.4 1.6 1.6 0 0 0-.59-.11c-.213 0-.413.037-.6.11a1.171 1.171 0 0 0-.5.4c-.14.193-.253.457-.34.79-.08.333-.12.76-.12 1.28v.2c0 .573.04 1.04.12 1.4.087.36.2.643.34.85.147.2.314.34.5.42.187.073.387.11.6.11ZM16.901 9h1l-4.8 7h-1l4.8-7Zm-4.2 3.3c-.233 0-.45-.04-.65-.12a1.52 1.52 0 0 1-.5-.33 1.61 1.61 0 0 1-.33-.52 1.868 1.868 0 0 1-.12-.68v-.1c0-.247.04-.47.12-.67.08-.2.19-.373.33-.52.14-.147.307-.26.5-.34.2-.08.417-.12.65-.12.234 0 .447.04.64.12.2.08.37.193.51.34.14.147.25.32.33.52.08.2.12.423.12.67v.1c0 .247-.04.473-.12.68-.08.2-.19.373-.33.52-.14.14-.31.25-.51.33-.193.08-.406.12-.64.12Zm0-.76a.694.694 0 0 0 .54-.22c.134-.147.2-.37.2-.67v-.1c0-.3-.066-.523-.2-.67a.694.694 0 0 0-.54-.22.694.694 0 0 0-.54.22c-.133.147-.2.37-.2.67v.1c0 .3.067.523.2.67.134.147.314.22.54.22Zm4.6 4.55c-.233 0-.45-.04-.65-.12a1.52 1.52 0 0 1-.5-.33 1.61 1.61 0 0 1-.33-.52 1.868 1.868 0 0 1-.12-.68v-.1c0-.247.04-.47.12-.67.08-.2.19-.373.33-.52.14-.147.307-.26.5-.34.2-.08.417-.12.65-.12.234 0 .447.04.64.12.2.08.37.193.51.34.14.147.25.32.33.52.08.2.12.423.12.67v.1c0 .247-.04.473-.12.68-.08.2-.19.373-.33.52-.14.14-.31.25-.51.33-.193.08-.406.12-.64.12Zm0-.76a.694.694 0 0 0 .54-.22c.134-.147.2-.37.2-.67v-.1c0-.3-.066-.523-.2-.67a.694.694 0 0 0-.54-.22.694.694 0 0 0-.54.22c-.133.147-.2.37-.2.67v.1c0 .3.067.523.2.67.134.147.314.22.54.22Z",
    fill: "#F44336"
  })));
};
/* harmony default export */ var service_free = (SvgServiceFree);
;// CONCATENATED MODULE: ./public/img/advantages/lock.svg
var lock_circle, lock_path;
function lock_extends() { lock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_extends.apply(this, arguments); }

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/react.createElement("svg", lock_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lock_circle || (lock_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), lock_path || (lock_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.19 10.518h.5V8.866c0-.654.224-1.202.687-1.671.462-.47.999-.695 1.636-.695.637 0 1.168.225 1.62.692.455.469.678 1.018.678 1.674v1.652h1.08c.159 0 .292.053.423.186a.59.59 0 0 1 .186.439v5.732a.59.59 0 0 1-.186.44.558.558 0 0 1-.422.185H8.635a.589.589 0 0 1-.449-.186.59.59 0 0 1-.186-.439v-5.732a.59.59 0 0 1 .186-.44.588.588 0 0 1 .449-.185h.554Zm4.565 0h.5V8.866c0-.615-.225-1.156-.658-1.596A2.178 2.178 0 0 0 12 6.598c-.62 0-1.16.23-1.588.676-.424.441-.64.98-.64 1.592v1.652h3.983ZM12 15.66c.444 0 .836-.168 1.148-.484a1.62 1.62 0 0 0 .474-1.168 1.62 1.62 0 0 0-.474-1.168A1.571 1.571 0 0 0 12 12.357c-.444 0-.836.167-1.148.484a1.62 1.62 0 0 0-.474 1.168c0 .449.16.848.474 1.168.312.316.704.484 1.148.484Z",
    stroke: "#F44336"
  })));
};
/* harmony default export */ var lock = (SvgLock);
;// CONCATENATED MODULE: ./public/img/advantages/bank_card.svg
var bank_card_circle, bank_card_path, _path2, _path3;
function bank_card_extends() { bank_card_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bank_card_extends.apply(this, arguments); }

var SvgBankCard = function SvgBankCard(props) {
  return /*#__PURE__*/react.createElement("svg", bank_card_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bank_card_circle || (bank_card_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), bank_card_path || (bank_card_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.33 14.667a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 13c0-.543.264-1.021.667-1.325a1.647 1.647 0 0 0-1-.342 1.667 1.667 0 1 0 0 3.334c.361-.001.713-.121 1-.342A1.658 1.658 0 0 1 12 13Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    stroke: "#F44336",
    strokeLinejoin: "round",
    d: "M6.516 7.611h10.973v8.779H6.516z"
  })));
};
/* harmony default export */ var bank_card = (SvgBankCard);
;// CONCATENATED MODULE: ./public/img/advantages/cancel.svg
var cancel_circle, cancel_path, cancel_path2;
function cancel_extends() { cancel_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cancel_extends.apply(this, arguments); }

var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/react.createElement("svg", cancel_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), cancel_circle || (cancel_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), cancel_path || (cancel_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.858 7.002a5.465 5.465 0 0 0-4.032 1.93l-.807-.8a.305.305 0 0 0-.519.22v2.621c0 .171.134.306.306.306h2.62c.276 0 .41-.33.214-.52l-.947-.953A4.275 4.275 0 0 1 12 8.224c2.64 0 4.729 2.407 4.191 5.138-.33 1.693-1.717 3.043-3.409 3.343a4.275 4.275 0 0 1-4.918-3.153.616.616 0 0 0-.587-.44.61.61 0 0 0-.599.751A5.494 5.494 0 0 0 12 18a5.501 5.501 0 0 0 5.499-5.658c-.086-2.982-2.658-5.414-5.64-5.34Z",
    fill: "#F44336"
  })), cancel_path2 || (cancel_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 9.75v3l2 1.5",
    stroke: "#F44336",
    strokeLinecap: "round"
  })));
};
/* harmony default export */ var cancel = (SvgCancel);
;// CONCATENATED MODULE: ./public/img/advantages/circle.svg
var circle_circle;
function circle_extends() { circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_extends.apply(this, arguments); }

var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/react.createElement("svg", circle_extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), circle_circle || (circle_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })));
};
/* harmony default export */ var circle = (SvgCircle);
;// CONCATENATED MODULE: ./public/img/advantages/payment-on-spot.png
/* harmony default export */ var payment_on_spot = ({"src":"/_next/static/media/payment-on-spot.804650ea.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAclBMVEX////+/v7////+/v7////////+/v7////+/f3////+/v7+/f3////+/v7+/v7+/f3////96+r84d/829n////+/v7+/f3////+/v7+/f3+/Pz96ej95+X84eD84N/83tz83Nv819X7ycb6xML6wr/6vbpY7Q9kAAAAF3RSTlMAACwsLS4uvLy/v7/u7vj4+fn5+fr6+vByt/UAAABFSURBVHjaDcGFAYAgAATAtwCRMHns3n9FvQNy7YNKgdTyZwsoNtfRUSNwf9ebDp7bc84cULFdWEcJYcYpRpMhyWTvSpF8ncQEXrm46pgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/img/pushkin.svg
var pushkin = __webpack_require__(7890);
// EXTERNAL MODULE: ./components/blocks/Description.tsx
var Description = __webpack_require__(3162);
;// CONCATENATED MODULE: ./components/styled/LabelEvent.js



function LabelEvent(_ref) {
  var text = _ref.text,
      description = _ref.description;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    title: description,
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      display: 'block',
      background: theme.colors.red,
      borderRadius: 2,
      fontFamily: 'Golos',
      fontWeight: 500,
      fontSize: 12,
      color: theme.colors.white,
      padding: '4px 10px'
    },  true ? "" : 0,  true ? "" : 0),
    children: text
  });
}
// EXTERNAL MODULE: ./components/collapsable/collapsable.tsx + 1 modules
var collapsable = __webpack_require__(4052);
// EXTERNAL MODULE: ./components/comments/CommentsBlock.tsx + 9 modules
var CommentsBlock = __webpack_require__(2754);
// EXTERNAL MODULE: ./components/about/Subscription.tsx
var Subscription = __webpack_require__(6911);
// EXTERNAL MODULE: ./components/about/MobileApps.tsx + 3 modules
var MobileApps = __webpack_require__(8556);
// EXTERNAL MODULE: ./components/viewed/viewed.tsx
var viewed_viewed = __webpack_require__(5705);
// EXTERNAL MODULE: ./utils/viewed.js
var utils_viewed = __webpack_require__(6339);
// EXTERNAL MODULE: ./components/common/UpButton.tsx + 1 modules
var UpButton = __webpack_require__(7406);
// EXTERNAL MODULE: ./components/blocks/ActionWidget.tsx
var ActionWidget = __webpack_require__(2067);
// EXTERNAL MODULE: ./components/picture/PictureModal.tsx + 1 modules
var PictureModal = __webpack_require__(4149);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(6310);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(7533);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js + 1 modules
var parsePhoneNumber = __webpack_require__(8805);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(2837);
// EXTERNAL MODULE: ./components/styled/Close.tsx
var Close = __webpack_require__(2750);
// EXTERNAL MODULE: ./models/modal.ts
var models_modal = __webpack_require__(5493);
// EXTERNAL MODULE: ./components/form/input.js + 4 modules
var input = __webpack_require__(3609);
// EXTERNAL MODULE: ./components/styled/Form.tsx
var Form = __webpack_require__(6783);
// EXTERNAL MODULE: ./components/form/form.js
var form_form = __webpack_require__(5546);
// EXTERNAL MODULE: ./components/calendar/calendar.tsx + 1 modules
var calendar_calendar = __webpack_require__(6195);
;// CONCATENATED MODULE: ./public/img/fire-logo.svg
var fire_logo_path;
function fire_logo_extends() { fire_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fire_logo_extends.apply(this, arguments); }

var SvgFireLogo = function SvgFireLogo(props) {
  return /*#__PURE__*/react.createElement("svg", fire_logo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 18",
    fill: "none"
  }, props), fire_logo_path || (fire_logo_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.49 8.24a6.214 6.214 0 0 0-1.413-2.06l-.496-.477a.136.136 0 0 0-.125-.032.136.136 0 0 0-.06.033.146.146 0 0 0-.036.058l-.222.667c-.138.419-.392.846-.752 1.266a.104.104 0 0 1-.07.036.091.091 0 0 1-.073-.027.108.108 0 0 1-.034-.085c.063-1.077-.244-2.291-.915-3.613C7.738 2.908 6.966 2.052 6 1.454l-.704-.434c-.092-.058-.21.018-.204.13l.037.859c.026.586-.04 1.105-.192 1.536a5.166 5.166 0 0 1-1.611 2.282 6.25 6.25 0 0 0-1.71 2.172A6.47 6.47 0 0 0 1 10.76c0 .844.159 1.661.472 2.432a6.27 6.27 0 0 0 1.287 1.983 5.978 5.978 0 0 0 1.907 1.336c.74.325 1.524.49 2.334.49s1.594-.165 2.334-.488a5.931 5.931 0 0 0 1.907-1.336 6.211 6.211 0 0 0 1.287-1.983A6.418 6.418 0 0 0 13 10.76c0-.873-.17-1.72-.51-2.52Zm-2.064 6.069a4.719 4.719 0 0 1-6.852 0 5.091 5.091 0 0 1-1.415-3.548c0-.778.167-1.524.496-2.218a5.013 5.013 0 0 1 1.377-1.75 6.1 6.1 0 0 0 1-1.016c.425-.546.76-1.154.991-1.807.095-.269.164-.547.207-.831.41.397.755.876 1.043 1.438.569 1.12.832 2.115.78 2.963-.012.2.02.4.091.585.072.185.183.35.325.484.123.117.267.206.423.264a1.224 1.224 0 0 0 1.357-.364c.227-.266.423-.538.586-.815a5.164 5.164 0 0 1 1.006 3.067c0 1.339-.503 2.6-1.415 3.548Z",
    fill: "#F44336",
    stroke: "#F44336",
    strokeWidth: 0.5
  })));
};
/* harmony default export */ var fire_logo = (SvgFireLogo);
;// CONCATENATED MODULE: ./public/img/payment-marks.svg
var payment_marks_path, payment_marks_path2, payment_marks_path3, _path4, _path5, _path6, _defs;
function payment_marks_extends() { payment_marks_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return payment_marks_extends.apply(this, arguments); }

var SvgPaymentMarks = function SvgPaymentMarks(props) {
  return /*#__PURE__*/react.createElement("svg", payment_marks_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 16",
    fill: "none"
  }, props), payment_marks_path || (payment_marks_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.191 5.948c-.02 1.585 1.41 2.47 2.487 2.995 1.107.54 1.48.886 1.475 1.368-.009.739-.883 1.065-1.702 1.078-1.428.022-2.258-.387-2.918-.696l-.514 2.412c.662.306 1.888.572 3.16.584 2.985 0 4.938-1.476 4.948-3.765.012-2.904-4.01-3.065-3.983-4.363.01-.394.385-.814 1.206-.92.407-.055 1.53-.096 2.802.491l.5-2.333a7.607 7.607 0 0 0-2.66-.489c-2.809 0-4.785 1.497-4.801 3.638Zm12.262-3.436c-.546 0-1.005.318-1.21.807L24.98 13.517h2.983l.594-1.643H32.2l.345 1.643h2.629L32.88 2.512h-2.428Zm.417 2.973.86 4.132h-2.357l1.497-4.132ZM14.575 2.512l-2.351 11.005h2.842l2.35-11.005h-2.841Zm-4.205 0-2.959 7.49-1.196-6.369c-.14-.711-.695-1.121-1.311-1.121H.068L0 2.83c.993.216 2.12.564 2.804.936.418.228.538.427.675.967l2.267 8.783H8.75l4.605-11.005H10.37Z",
    fill: "#1434CB"
  })), payment_marks_path2 || (payment_marks_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M63.977 1.71H56.99v12.58h6.987V1.71Z",
    fill: "#FF5F00"
  })), payment_marks_path3 || (payment_marks_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M57.434 8.001a7.997 7.997 0 0 1 3.05-6.29 7.978 7.978 0 0 0-11.703 2.046 8.01 8.01 0 0 0 3.279 11.438 7.973 7.973 0 0 0 8.424-.905A7.984 7.984 0 0 1 57.434 8Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M73.404 8.001a8.01 8.01 0 0 1-1.216 4.244 7.991 7.991 0 0 1-3.28 2.95 7.972 7.972 0 0 1-8.424-.906A7.997 7.997 0 0 0 63.534 8a8.011 8.011 0 0 0-3.05-6.29 7.977 7.977 0 0 1 11.704 2.045 8.009 8.009 0 0 1 1.216 4.244V8Z",
    fill: "#F79E1B"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M120.97 2.31h-7.548c.439 2.497 2.858 4.846 5.496 4.846h6.009c.073-.22.073-.588.073-.808 0-2.202-1.832-4.037-4.03-4.037Z",
    fill: "url(#payment-marks_svg__a)"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M114.081 7.596v6.093h3.664v-3.23h3.225c1.758 0 3.297-1.248 3.81-2.863h-10.699ZM101.184 2.31v11.306h3.225s.806 0 1.245-.808c2.199-4.33 2.858-5.652 2.858-5.652h.44v6.46h3.664V2.31h-3.224s-.806.073-1.246.807c-1.832 3.744-2.858 5.653-2.858 5.653h-.44V2.31h-3.664ZM85.795 13.69V2.385h3.664s1.026 0 1.612 1.615c1.466 4.257 1.613 4.845 1.613 4.845S92.977 7.817 94.296 4c.586-1.615 1.612-1.615 1.612-1.615h3.664V13.69h-3.664V7.597h-.44l-2.052 6.093h-1.612l-2.052-6.093h-.44v6.093h-3.517Z",
    fill: "#4FAD50"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "payment-marks_svg__a",
    x1: 113.245,
    y1: 5.155,
    x2: 124.603,
    y2: 5.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#00B4E6"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })))));
};
/* harmony default export */ var payment_marks = (SvgPaymentMarks);
;// CONCATENATED MODULE: ./public/img/tinkoff.svg
var _g, tinkoff_defs;
function tinkoff_extends() { tinkoff_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tinkoff_extends.apply(this, arguments); }

var SvgTinkoff = function SvgTinkoff(props) {
  return /*#__PURE__*/react.createElement("svg", tinkoff_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 32",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#tinkoff_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M32.845 11.46a1.736 1.736 0 0 1-.218-.312 15.148 15.148 0 0 0-.128-.203c.13-.16.24-.344.322-.546l.33-.802-.814-.125a6.567 6.567 0 0 1-.618-.156c-.5-.14-1.141-.319-1.84-.396a1.28 1.28 0 0 0 .584-.585l.134-.257s-.036-.36-.167-.473a1.7 1.7 0 0 0 .115-.368l.111-.575-.52-.189c-.08-.029-.16-.05-.243-.065a1.891 1.891 0 0 0-.133-.333l-.308-.602-.557.346c-.131.08-.25.18-.352.298a1.35 1.35 0 0 0-.265-.026s-.318-.038-.67.098l-.448-.496-.532-.604c-.498-.566-1.173-.734-1.86-.455-.26-.279-.67-.51-1.305-.51-.215 0-.404.028-.515.044 0 0-.874.169-1.365.666l-.596-.303a2.13 2.13 0 0 1-1.083.882 1.645 1.645 0 0 0-.24-.547l.039-.236c0-.006.134-.804.543-1.482l.71-1.178-1.007.121a3.138 3.138 0 0 0-.016-.381l-.09-.917-.79.381c-.087.041-.16.082-.229.12l-.156-.353-.362.2a3.196 3.196 0 0 0-.146-.328L17.742 0l-.59.679a2.516 2.516 0 0 0-.157.196l-.358-.38-.362.381a2.992 2.992 0 0 0-.156-.196L15.52 0l-.419.817a3.11 3.11 0 0 0-.144.325l-.36-.2-.157.354a4.412 4.412 0 0 0-.23-.122l-.792-.38-.088.92a2.932 2.932 0 0 0-.015.379l-1.01-.121.714 1.178c.41.676.54 1.474.54 1.48l.039.237c-.113.164-.194.35-.241.547 0 0-.646-.294-1.078-.883l-.61.309c-.693-.498-1.124-.692-1.872-.716-.635-.018-1.045.231-1.306.51-.688-.277-1.361-.11-1.857.456 0 0-.326.377-.533.604-.205.229-.51.42-.51.42s-.432-.105-.876.004a1.531 1.531 0 0 0-.355-.299l-.56-.347-.306.606a1.693 1.693 0 0 0-.129.33 1.34 1.34 0 0 0-.242.065l-.518.193.107.57c.027.138.065.261.116.372a1.54 1.54 0 0 0-.078.195l-.087.277.132.257c.14.27.342.473.582.584-.7.079-1.34.258-1.841.396-.258.072-.48.135-.617.157L.103 9.6l.186.448.148.357c.084.2.195.384.323.543-.048.073-.255.417-.346.514L0 11.91l.396.464c.05.057.495.554 1.214.555.197 0 .392-.037.585-.11.192.319.42.643.628.802-.383.478-.818.893-1.438 1.207l-.517.262.222.63c.146.38.428.795.975.955-.118.371-.174.724-.224 1.037-.117.745-.167 1.054-.783 1.285l-.554.206.159.6c.128.49.32.814.527 1.028l-.368.432s.874.697 1.73.781c.013.002.743.052 1.071-.393.13.505.339.97.527 1.39.387.867.594 1.38.334 1.848L3.9 25.944l1.15-.052c.502-.021.97-.054 1.373-.16a.95.95 0 0 1-.003.065l-.093.907 1.008-.226c.106-.033.205-.078.296-.13.624.777 1.685 1.383 3.114 1.383h.083l-1.643.717 1.197.663c.788.436 1.663.801 2.662 1.112l-.139.51.6.187c.347.108 1.6.461 3.126.461 1.527 0 2.777-.353 3.126-.461l.599-.188-.14-.508c1.001-.31 1.876-.675 2.665-1.112l1.196-.662-1.644-.717h.082c1.43 0 2.49-.606 3.113-1.383.09.051.19.096.297.13l1.008.226-.092-.905a.979.979 0 0 1-.004-.068c.403.106.871.137 1.372.161l1.15.051-.582-1.054c-.26-.467-.053-.98.332-1.847.19-.422.396-.886.528-1.39.222.178.46.287.697.342 0 0 .184.059.36.063.51.017.764-.137 1.113-.37l.635-.426-.37-.432c.207-.212.398-.535.527-1.024l.16-.602-.555-.205c-.618-.231-.667-.54-.784-1.286-.05-.313-.104-.666-.223-1.037.546-.16.827-.577.972-.956l.222-.63-.518-.263c-.62-.314-1.055-.728-1.439-1.207.209-.159.437-.483.63-.801.192.073.388.108.586.11.226-.003.45-.053.659-.148a1.72 1.72 0 0 0 .555-.405l.396-.465-.414-.451Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.56 19.64v-5.063c0-.47-.129-.942-.282-1.376h3.694c.338.496.953.827 1.658.827.703 0 1.318-.332 1.657-.827h3.694c-.156.436-.282.906-.282 1.377v5.062h-10.14Zm5.069 6.918c-.516-.547-.885-.606-2.277-.606-1.663 0-2.793-1.038-2.793-2.696v-3.32h10.138v3.32c0 1.658-1.128 2.696-2.795 2.696-1.39-.002-1.759.06-2.273.606Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.148 27.183v1.011l-.826.354c.697.337 1.564.672 2.58.92l.469-1.623c-.999-.217-1.695-.444-2.223-.662Zm4.48 1.37c-.975 0-1.795-.108-2.123-.188l-.494 1.701c.777.203 1.686.352 2.618.352a10.508 10.508 0 0 0 2.618-.352l-.496-1.701c-.328.082-1.145.188-2.122.188Zm4.482-1.37c-.53.218-1.225.444-2.224.665l.47 1.621c.887-.213 1.751-.521 2.58-.92l-.824-.353v-1.013h-.002ZM10.418 10.876c1.292-.741 4.45-2.375 2.31-4.135-.292-.24-.614-.455-.884-.723-.334.275.125.955.241 1.204 0 0-.713.076-.884.076-1.101-.005-2.256-.7-1.67-2.029-.439.097-.492.545-.626.928-.281-.202-.77-.637-1.146-.576.306 1.041 1.593 1.979 2.592 2.192-1.01.584-2.882 1.018-3.867-.24-.69 1.423.273 2.017 1.217 2.762-3.595 1.745-3.063 3.702-5.421 5.242.306.152 1.67-.155 1.791-.173-.512.706-.75 1.004-.9 1.348-.144.322-.208.686-.35 1.469-.11.619-.313 1.236-1.022 1.646.278.534.894.116 1.152.045-.035.057-.122.7-.353 1.01 1.211-.082.65-2.797 1.861-2.143.342.183.444.61.287.96-.795 1.747 1.013 3.285.915 4.816.444-.004.905-.017 1.195-.656.15.319.385.767.516 1.198l.362-.655c.224 1.085 1.176 2.087 2.461 2.177-.613-1.032.122-2.442-1.369-3.94.187-.16.615-.466.769-.675-1.83.228-3.738-1.31-2.871-2.04.566-.477.814.512 1.688.346l-.342-.313c.12-.127.258-.29.4-.415-.372-.048-.777-.3-.777-.3l.221-.39c-2.143-.004-2.197-1.747-1.326-1.816.409-.032.938.77 2.256.602-.169-.216-.236-.543-.315-.784.318-.03.692-.028.994-.184-.645-.088-.807-.318-1.344-.75l.623-.242c-.903-.48-.85-1.315-.877-2.184.473.288 1.028.736 1.621.53.14-.051.23-.12.234-.277-.845-.36-1.389-1.745.638-2.91Zm-1.543.137c-1.131 1.286-.641 2.056-.413 2.293-.422-.096-1.05-.667-.907-1.22-.134.171-.272.357-.412.548-.267.378-.518.767-.755 1.167-.344 1.085.286 2.206 1.356 2.702-1.19-.186-1.723-1.31-1.72-2.028-.567 1.142-.839 2.184-.814 3.059.01.325.037.63.078.916.273.551.711.754 1.493.854-.71.05-1.086.014-1.395-.331.484 2.212 2.747 4.127 3.667 5.768-.922-1.275-2.83-3.174-3.498-4.547-.052.496.073 1.768.653 2.55-.855-.895-.922-2.25-.865-3.043a5.808 5.808 0 0 1-.373-1.933A8.43 8.43 0 0 1 5.092 16c-.54.817-1.32 1.133-1.704 2.376.074-1.604 1.2-1.628 2.042-3.575.326-.851.8-1.587 1.325-2.42-.667.232-1.166.398-1.937 1.296.548-1.378 3.712-2.926 5.162-4.425-.435.098-2.213.146-2.95-.378 1.336.384 4.312-.055 5.436-.872-.776 1.187-2.464 1.255-4.519 3.615.288-.237.599-.44.928-.605Zm21.56 7.208c-.142-.783-.205-1.147-.349-1.469-.147-.344-.388-.642-.901-1.348.122.018 1.488.325 1.793.173-2.358-1.54-1.828-3.497-5.422-5.242.944-.745 1.906-1.34 1.215-2.763-.985 1.26-2.857.825-3.866.24 1-.214 2.286-1.15 2.591-2.192-.378-.061-.866.373-1.146.574-.135-.383-.187-.832-.625-.93.585 1.332-.57 2.026-1.674 2.03-.168 0-.88-.076-.88-.076.114-.249.573-.93.236-1.204-.269.27-.587.484-.881.723-2.142 1.761 1.02 3.396 2.311 4.136 2.024 1.166 1.486 2.551.638 2.906.004.156.094.226.237.276.589.209 1.148-.24 1.617-.53-.026.87.03 1.707-.874 2.185l.621.242c-.537.431-.697.663-1.341.75.3.156.677.153.994.184-.081.24-.152.568-.317.784 1.32.165 1.85-.635 2.256-.603.867.07.816 1.813-1.328 1.816l.222.39s-.406.252-.779.3c.142.123.281.29.401.416l-.341.313c.872.166 1.121-.822 1.688-.347.866.73-1.041 2.269-2.872 2.04.155.21.584.518.77.677-1.492 1.497-.758 2.908-1.369 3.942 1.283-.091 2.235-1.093 2.461-2.179l.362.655c.13-.43.367-.879.515-1.197.288.638.752.652 1.199.655-.102-1.53 1.705-3.07.912-4.815-.16-.349-.056-.778.286-.961 1.214-.654.65 2.062 1.863 2.145-.233-.311-.319-.955-.35-1.012.254.072.87.49 1.147-.046-.704-.402-.906-1.02-1.02-1.638ZM28.168 16c.095.521.143 1.099.122 1.766a5.846 5.846 0 0 1-.374 1.934c.055.793-.01 2.148-.865 3.042.578-.783.705-2.053.653-2.55-.67 1.373-2.578 3.272-3.502 4.546.923-1.64 3.185-3.556 3.67-5.767-.312.343-.684.38-1.396.332.78-.102 1.218-.304 1.492-.855.042-.303.068-.61.078-.916.027-.875-.247-1.917-.815-3.059.005.717-.529 1.842-1.72 2.028 1.068-.498 1.699-1.618 1.357-2.702-.222-.378-.472-.77-.755-1.167-.141-.19-.279-.376-.414-.547.143.553-.485 1.123-.907 1.22.23-.238.718-1.008-.412-2.294.317.16.667.383.93.602-2.054-2.36-3.741-2.426-4.52-3.615 1.125.817 4.1 1.258 5.436.872-.736.524-2.515.476-2.95.378 1.45 1.499 4.617 3.048 5.163 4.425-.77-.898-1.272-1.064-1.935-1.296.526.834.997 1.568 1.323 2.42.845 1.947 1.971 1.97 2.044 3.575-.384-1.24-1.162-1.555-1.703-2.372Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.286 13.2c-.34.495-.955.827-1.656.827-.164 0-.322-.02-.471-.05.043.204.14.415.345.596-.083.592.158 1.147.755 1.291.064.302.238.53.535.637l-.416.51a.62.62 0 0 1-.242.19.583.583 0 0 1-.297.047l-1.86-.224c.082-.219-.134-.472-.724-.366l.731-2.173-.445-1.008-.844.767-.063 2.281-.364-.188c-.468-.216-.607.692-.16.695l.179.002c-.012.093.016.196.086.229-.084.037-.109.204-.004.264-.106.055-.122.228-.036.302-.093.168-.11.531.216.623.27.074.438-.231.492-.409l2.895.953c.407.125.7.055 1.04-.262l.755-.703c-.095.46.06.873.389 1.011 0 0-.052.422-.032.596l1.013.002h1.595v-5.063c0-.47.127-.942.283-1.377h-3.695Zm-4.335 8.518.056.075c.078.103.125.078.214.023l.13-.075c.084-.066.622.152.652-.324.06.356-.339 1.105-.099 1.522l.323.564-1.054.015a.213.213 0 0 0-.124.038.233.233 0 0 0-.084.104l-.276.609c-.072.16-.067.328.024.438l.186.224s.153-.137.203-.318l-.083-.092c-.068-.07-.068-.136-.03-.222l.17-.375c.065-.148.132-.18.282-.141l.853.196c.063.016.164.048.225-.064.105-.198.29-.21.476-.179.468.075 1.55.195 1.935-.285.452.639 1.337.639 1.28.974l-.188 1.099h.281l.172-1.124c.018-.131.095-.31-.038-.411-.054-.045-.08-.069-.203-.294-.16-.3-.152-.747-.308-1.134.148-.184.307-.247.445-.212.313.08.397.654.84 1.12-.05-.207-.071-.434-.176-.632 0 0 .308.253.387.55.05.186.101.323.259.409.104.04.23-.013.354-.172 0 0-.292-.442-.506-.731-.293-.396-.685-.795-1.218-.748-.169.015-.33.096-.486.194-.606-.362-1.078.021-1.265.021l-1.136-.071c-.223-.016-.4-.29-.4-.29-.027-1.023-.8-1.43-1.067-1.43 0 0 .025-.183-.045-.248l-.237.317-.659-.256.516.45-.559.692c-.058.068-.05.157-.022.194Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.207 23.154c-.16.13-.152.313-.056.518l.095.189.248-.202-.056-.13c-.04-.09-.04-.183.031-.24l.356-.286c.1-.078.13-.086.237-.07l.75.167s-.114-.175-.151-.355l-.707-.099c-.1-.014-.16.03-.248.103l-.5.405Zm4.8 2.37h.283l.456-1.193c.016-.042.037-.06.054-.096a3.211 3.211 0 0 1-.494-.25c.114.163.203.232.156.384l-.456 1.155Zm.241-16.141.526-3.215-1.992.72v3.314l1.466-.82Zm-1.129-2.17 1.322-.518s-.258.223-.566.447c-.272.2-.756.415-.756.415V7.213Zm0 .779 1.209-.46s-.145.162-.451.386c-.273.2-.756.414-.756.414v-.34h-.002Zm0 .826 1.064-.434s0 .137-.307.36c-.274.2-.757.415-.757.415v-.34Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m14.703 12.226.044.074h.41l.005.076c.005.074.02.148.043.225.065.207.191.424.394.6.236.203.575.35 1.028.35.982 0 1.424-.676 1.467-1.174l.003-.076h.412l.043-.075c.387-.644.86-1.36 1.41-1.463l-1.498-.924-1.837 1.062L14.79 9.84l-1.496.924c.549.102 1.022.819 1.41 1.463Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.473 10.202V6.888l-1.99-.72.523 3.215 1.466.819Zm-.336-1.04s-.484-.216-.757-.415c-.307-.223-.307-.362-.307-.362l1.066.435v.342h-.002Zm0-1.95v.345s-.484-.214-.757-.415a10 10 0 0 1-.568-.446l1.325.518v-.001Zm0 .78v.342s-.484-.214-.757-.414c-.309-.224-.452-.386-.452-.386l1.21.458Zm.492-3.242c-1.138 0-1.991.397-2.177.861l2.177.915 2.173-.915c-.184-.464-1.036-.86-2.173-.86Zm0-1.328c.837 0 1.677.27 2.241.621a4.25 4.25 0 0 1 .325-.818l-.515.084-.416-.945-.779.439-.856-.901-.859.901-.777-.44-.42.947-.514-.085c.134.264.23.495.326.818.566-.35 1.403-.62 2.244-.62Zm14.199 7.287c.281-.039.507-.138.783-.357-.595-.168-1.84-.648-2.902-.431-.351.05-.546.2-.421.286.57.404 1.276 1.338 1.789 2.428.451-.595.262-1.377.167-1.601.899.576 1.134.856 1.55.746-.221-.363-.535-.69-.966-1.071ZM3.18 12.634c.513-1.09 1.218-2.025 1.791-2.428.128-.086-.07-.237-.418-.288-1.064-.213-2.313.265-2.907.432.28.22.501.319.785.357-.432.383-.745.709-.97 1.072.42.11.655-.17 1.552-.747-.092.226-.283 1.006.167 1.602Z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41 22.755c.414-.348.757-.523.74-1.368-.621.34-2.383.32-3.119-.758-.208-.307.015-.461.215-.22.504.608 1.437.333 1.778.159-.055-.21-.207-.482-.333-.598.128-.132.489-.332.562-.674-.192-.111-.939-.19-.939-.19.12-.123.27-.295.18-.751-.764.25-1.708-.09-1.921-.39-.212-.295.004-.572.182-.377.38.425 2.256.912 2.954.173-.26-.076-.545-.322-.597-.475.646-.07 1.161-.475 1.204-.979-.358 0-1.032-.028-1.263-.211.309-.121.506-.24.604-.61-1.181-.076-1.275-1.008-1.281-1.162.77.471 2.123.262 1.773-.9-.64-.037-1.285-1.137.474-2.148 1.599-.921 3.417-1.913 3.256-3.548-.104-1.046-1.722-1.76-1.928-2.289-.676.342-.812.74-.507 1.404 0 0-1.506.16-1.625-.826-.052-.442.226-.855.525-1.172-.169 0-1.303-.324-1.645.659-.635-.462-1.18-.445-1.608.043.684.432 1.107 1.912 2.236 2.349-.802.463-2.102.269-2.861-1.155-.718 1.15-1.131 2.288.408 3.504-2.8 1.357-2.78 3.95-5.217 5.184.246.705.767.705 1.433.596-1.054 1.455-.157 2.98-1.824 3.602.155.594.469 1.069 1.084.894-.175.29-.29.284-.562.602.912.612 1.992.17 2.238-1.79.043-.35.496-.131.34.213-1.04 2.285 1.588 4.004.659 5.68.819-.036 1.444-.104 1.784-.398.167.352.269.701.232 1.044.452-.098.617-.381.648-.71.297.922 1.358 1.905 3.055 1.905-.9-1.367-.063-2.753-1.334-4.312ZM7.734 24.44l-.362.655c-.129-.431-.365-.88-.516-1.198-.291.64-.752.652-1.195.655.098-1.53-1.71-3.068-.915-4.815.16-.348.055-.776-.286-.96-1.213-.654-.65 2.061-1.862 2.144.23-.31.318-.955.353-1.01-.258.07-.875.489-1.152-.046.709-.409.911-1.027 1.022-1.646.14-.784.206-1.147.348-1.469.15-.343.389-.642.9-1.348-.122.019-1.483.326-1.791.173 2.357-1.54 1.827-3.497 5.42-5.242-.942-.744-1.904-1.339-1.215-2.761.985 1.258 2.856.823 3.867.239-.999-.213-2.286-1.149-2.59-2.191.376-.061.864.373 1.143.576.136-.385.19-.831.627-.928-.585 1.33.57 2.023 1.671 2.028.172 0 .884-.076.884-.076-.115-.25-.575-.93-.24-1.204.27.27.59.484.883.722 2.142 1.763-1.018 3.397-2.31 4.138-2.027 1.166-1.483 2.553-.638 2.907-.003.155-.093.225-.234.275-.593.21-1.148-.24-1.621-.53.029.87-.029 1.707.877 2.185l-.623.24c.536.434.7.663 1.344.753-.3.156-.674.152-.994.184.081.24.146.567.315.783-1.318.166-1.847-.634-2.256-.602-.871.069-.817 1.812 1.325 1.815l-.22.39s.405.252.778.301c-.142.122-.28.289-.4.415l.342.313c-.874.167-1.122-.822-1.69-.346-.866.73 1.043 2.269 2.872 2.04-.154.208-.584.518-.769.677 1.491 1.497.756 2.907 1.37 3.941-1.286-.089-2.238-1.093-2.462-2.177Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.383 18.973c.31.343.685.38 1.395.331-.78-.101-1.22-.303-1.493-.854a9.004 9.004 0 0 1-.076-.916c-.025-.875.246-1.917.814-3.06-.003.716.529 1.841 1.72 2.029-1.07-.498-1.7-1.618-1.357-2.702.224-.379.475-.77.756-1.167.14-.19.278-.377.412-.548-.144.553.485 1.124.906 1.22-.228-.237-.718-1.005.414-2.292-.329.167-.64.368-.93.602 2.053-2.36 3.743-2.426 4.519-3.614-1.124.816-4.1 1.257-5.437.871.738.524 2.516.476 2.95.379-1.447 1.498-4.612 3.047-5.16 4.424.77-.899 1.27-1.063 1.937-1.294-.526.835-.998 1.569-1.324 2.42-.843 1.945-1.97 1.97-2.043 3.573C3.77 17.132 4.55 16.817 5.09 16a8.54 8.54 0 0 0-.124 1.766c.02.725.157 1.362.373 1.934-.054.793.012 2.148.867 3.042-.58-.782-.706-2.053-.654-2.55.67 1.373 2.577 3.272 3.5 4.546-.923-1.638-3.183-3.553-3.67-5.765Zm21.123-6.591c.663.232 1.164.396 1.935 1.296-.547-1.378-3.715-2.926-5.164-4.425.436.096 2.215.146 2.95-.378-1.335.387-4.31-.055-5.435-.872.777 1.189 2.465 1.255 4.52 3.615-.29-.234-.601-.436-.93-.602 1.13 1.287.641 2.056.412 2.294.421-.097 1.05-.668.906-1.22.137.17.273.357.414.548.267.377.52.766.755 1.166.343 1.086-.286 2.206-1.354 2.703 1.19-.186 1.724-1.314 1.718-2.029.57 1.142.841 2.184.816 3.059-.01.325-.037.63-.078.916-.275.551-.713.754-1.493.855.71.046 1.084.012 1.396-.332-.485 2.213-2.746 4.128-3.67 5.768.924-1.275 2.83-3.174 3.502-4.547.051.497-.073 1.768-.654 2.55.855-.895.92-2.249.866-3.043.215-.57.35-1.208.372-1.933a8.386 8.386 0 0 0-.121-1.766c.541.816 1.32 1.132 1.705 2.375-.073-1.605-1.2-1.63-2.044-3.575-.327-.856-.798-1.59-1.324-2.422v-.001Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.17 16.021c.662.112 1.183.112 1.431-.594-2.436-1.234-2.416-3.825-5.217-5.183 1.54-1.215 1.125-2.354.409-3.505-.757 1.423-2.062 1.618-2.862 1.155 1.127-.436 1.552-1.917 2.236-2.349-.427-.487-.973-.504-1.609-.043-.343-.982-1.476-.659-1.646-.659.297.316.577.729.524 1.172-.116.986-1.622.827-1.622.827.304-.666.168-1.063-.508-1.404-.205.528-1.822 1.242-1.928 2.288-.162 1.635 1.658 2.628 3.256 3.549 1.76 1.01 1.114 2.112.476 2.147-.354 1.162 1 1.372 1.771.9-.003.154-.1 1.088-1.283 1.164.1.368.296.487.605.61-.231.183-.906.21-1.262.21.043.504.56.91 1.206.979-.052.152-.34.398-.597.474.698.74 2.573.252 2.954-.172.175-.196.389.08.179.376-.215.303-1.157.641-1.921.39-.089.455.058.628.179.751 0 0-.748.08-.941.19.073.343.435.54.562.675-.129.116-.28.388-.334.597.343.175 1.275.45 1.777-.158.203-.24.424-.088.216.22-.736 1.078-2.497 1.095-3.12.758-.017.845.326 1.02.74 1.367-1.274 1.56-.433 2.945-1.333 4.31 1.696 0 2.757-.985 3.053-1.906.035.327.197.612.648.71-.034-.343.065-.692.231-1.043.344.293.969.36 1.788.397-.928-1.676 1.7-3.395.657-5.68-.155-.344.298-.564.342-.214.244 1.961 1.326 2.402 2.239 1.791-.274-.318-.389-.312-.563-.601.614.173.926-.301 1.084-.896-1.66-.62-.763-2.144-1.817-3.6Zm.14 3.891c.032.057.118.7.351 1.01-1.213-.082-.65-2.797-1.863-2.143-.342.183-.443.61-.285.96.792 1.747-1.015 3.285-.914 4.816-.446-.004-.91-.017-1.198-.656-.148.319-.387.767-.516 1.198l-.362-.655c-.225 1.085-1.177 2.087-2.46 2.179.61-1.032-.122-2.444 1.37-3.942-.188-.16-.617-.468-.772-.677 1.83.228 3.737-1.31 2.871-2.04-.566-.476-.817.513-1.688.347l.342-.314c-.12-.126-.26-.29-.401-.415.372-.048.779-.3.779-.3l-.223-.39c2.143-.004 2.195-1.746 1.328-1.816-.407-.032-.937.77-2.256.602.167-.215.236-.542.317-.783-.318-.031-.695-.028-.994-.184.645-.088.807-.319 1.342-.75l-.621-.242c.903-.48.846-1.316.874-2.185-.471.289-1.03.737-1.619.53-.14-.05-.232-.12-.235-.276.847-.355 1.387-1.741-.638-2.906-1.291-.742-4.451-2.376-2.31-4.136.292-.24.61-.455.88-.723.335.275-.124.955-.238 1.204 0 0 .711.076.88.076 1.103-.005 2.259-.698 1.674-2.03.439.097.49.546.624.93.281-.203.768-.636 1.146-.574-.306 1.04-1.59 1.978-2.59 2.19 1.009.585 2.88 1.02 3.866-.238.69 1.422-.272 2.016-1.215 2.762 3.594 1.742 3.063 3.7 5.422 5.242-.305.152-1.671-.156-1.793-.174.514.705.755 1.004.901 1.348.144.322.207.684.349 1.468.112.62.316 1.237 1.022 1.647-.276.53-.891.111-1.147.04Zm-17.12 4.284.515-.463-.079-.166c-.056-.12-.026-.126.034-.173l.27-.214c.064-.055.129-.048.206-.028l.812.203h-.858c-.198.013-.256.094-.328.25l-.059.128-.22.481a.568.568 0 0 0 .083.636l.156.198-.315.678h.265l.218-.471c.018-.017.34-.33.409-.654-.093-.081-.16-.138-.108-.251l.099-.226c.033-.075.043-.104.137-.086l.852.196c.106.032.262.081.376-.101.117-.19.132-.17.404-.141l.436.05c.595.06 1.189-.098 1.419-.294.081.196.242.346.317.5.028.056-.018.135-.054.236l-.489 1.241h.754l.426-1.132a.678.678 0 0 1 .14-.238l-.245 1.372h.732l.193-1.357c.043-.302.017-.398-.118-.522-.305-.275-.298-.85-.396-1.197a.272.272 0 0 1 .184-.038c.159.015.28.448.466.726.374.56.885 1.178 1.47.308a1.831 1.831 0 0 0-.189-.276l-.163-.204c-.096-.113-.549-.664-.737-.862-.43-.46-1.088-.39-1.35-.166-.594-.332-1.221.017-1.37.004l-1.023-.067a.193.193 0 0 1-.096-.03.21.21 0 0 1-.071-.074l.19-.067c-.178-.788-.625-1.447-1.407-1.561 0 0-.046-.25-.166-.297l-.234.292a.789.789 0 0 0-.196.058l-.999-.395.75.805s-.39.586-.5.705c-.073.11-.068.195.015.3l.145.202c.075.104.158.1.278.035l.164-.09c.071-.063.312.06.415-.039-.066.23-.098.45-.114.625l-.672-.087c-.147-.021-.214 0-.303.075l-.575.47c-.186.152-.244.416-.129.673l.234.52Zm5.556.135-.455 1.194h-.285l.456-1.156c.047-.15-.042-.22-.156-.382.169.101.29.168.494.25-.016.034-.038.052-.054.094Zm-4.393-2.588-.13.073c-.091.055-.136.08-.214-.023l-.056-.076c-.029-.037-.037-.125.02-.195l.559-.692-.515-.45.655.258.24-.32c.07.064.045.248.045.248.266 0 1.038.409 1.068 1.431 0 0 .175.274.397.289l1.139.073c.188 0 .659-.382 1.264-.022.154-.098.317-.175.486-.196.534-.041.927.354 1.218.752.215.29.508.73.508.73-.127.16-.25.213-.355.173-.157-.086-.209-.221-.258-.409-.08-.297-.387-.55-.387-.55.104.2.126.425.176.632-.445-.468-.53-1.04-.84-1.119-.137-.036-.297.027-.446.21.156.386.149.834.309 1.135.122.224.148.243.203.294.131.099.057.28.037.411l-.168 1.124h-.284l.187-1.099c.057-.335-.827-.335-1.28-.974-.385.48-1.466.36-1.934.285-.189-.03-.373-.016-.476.181-.061.111-.162.078-.225.06l-.853-.194c-.15-.037-.215-.006-.281.14l-.17.376c-.038.088-.036.152.032.224l.081.091a.75.75 0 0 1-.202.317l-.186-.222c-.09-.113-.095-.276-.023-.435l.276-.614c.033-.068.092-.142.208-.142l1.054-.015-.322-.56c-.241-.42.159-1.169.098-1.522-.033.472-.571.258-.656.322Zm-1.146 1.41.5-.404c.088-.072.148-.118.249-.105l.705.1c.04.179.152.355.152.355l-.751-.168c-.106-.013-.137-.008-.237.069l-.356.285c-.07.058-.073.15-.033.242l.057.13-.247.2-.095-.19c-.097-.2-.103-.384.056-.514Zm2.175-14.408c.273.201.757.415.757.415v-.342l-1.066-.433s0 .14.309.36Zm.755-.411v-.342l-1.209-.46s.143.162.452.386c.273.2.757.416.757.416Zm0-.777v-.343l-1.324-.518s.258.222.567.446c.273.2.757.415.757.415Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.859 12.226h1.354c-.056-.21-.267-.42-.662-.42-.374 0-.599.229-.692.42Zm-1.417-5.53-1.322.518v.343s.484-.214.757-.415c.307-.224.565-.446.565-.446Zm-.258 1.689-1.064.435v.342s.484-.216.757-.415c.307-.223.307-.362.307-.362Zm.144-.853-1.21.46v.342s.486-.214.757-.414a3.09 3.09 0 0 0 .453-.388Zm-5.625 4.274c-.394 0-.606.21-.662.42h1.356a.792.792 0 0 0-.292-.314.73.73 0 0 0-.403-.106h.001Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.319 5.773c0-.81-1.28-1.535-2.691-1.535-1.412 0-2.692.724-2.692 1.535l.03.199.561 3.44-2.668 1.655c-.284.178-.64.666-.685 1.157h.487c.081-.491.444-1.036 1.126-1.003.616.035.982.434 1.344 1.003l.093.15.134.223h-3.924c.289.617.562 1.27.562 1.979v8.679c0 2.232 1.612 3.296 3.357 3.296 1.349 0 1.531-.065 2.276.728.741-.793.924-.728 2.275-.728 1.744 0 3.358-1.064 3.358-3.296v-8.677c0-.709.272-1.363.561-1.978h-3.927l.136-.225.093-.15c.36-.569.727-.967 1.344-1.002.678-.033 1.046.511 1.125 1.002h.485c-.044-.49-.401-.98-.684-1.156l-2.668-1.655.564-3.44.028-.201Zm-4.838.395 1.992.72v3.314l-1.467-.82-.524-3.214Zm.49 7.032c.263.382.688.664 1.19.773.041.201.145.422.344.6-.082.592.156 1.145.755 1.29.063.303.24.53.534.638l-.416.51a.615.615 0 0 1-.241.191.578.578 0 0 1-.297.046l-1.86-.224c.08-.219-.135-.472-.723-.366l.732-2.173-.446-1.008-.846.767-.062 2.281-.36-.188c-.472-.216-.61.692-.16.695l.178.002c-.01.093.016.196.084.228-.084.038-.11.207-.003.266-.108.054-.122.227-.036.301-.093.168-.107.531.219.623.266.074.433-.231.488-.409l2.893.953c.41.125.7.055 1.04-.262l.756-.703c-.096.46.06.873.39 1.011 0 0-.047.414-.033.598h-7.533v-5.063c0-.47-.127-.942-.28-1.377h3.693Zm3.112 1.92c-.159.324-.143.696.043 1.033l-.124.13c-.543-.072-.757-.934-.757-.934-.01.078-.017.153-.015.229-.317-.124-.517-.423-.501-.833.12.072.254.122.397.148l.038-.252a.841.841 0 0 1-.685-.621c-.018-.002-.034-.007-.051-.008.066.005.134.012.202.012.225 0 .439-.037.638-.1.158.24.437.41.718.443-.045.198-.023.446.097.754v-.001Zm.803 2.278a.893.893 0 0 0-.126.265l-.303.296c.061-.473-.236-1.028-.509-1.255l.323-.335.063.07c-.108.3.103.889.552.96Zm-1.462-.148.25-.261c.253.236.588.762.482 1.263l-.271.266a.94.94 0 0 1-.173.137c.17-.446-.048-1.133-.288-1.405Zm-.536.22h.007c.094.014.189 0 .275-.04.19.29.339.947.111 1.357-.127.001-.253-.019-.375-.059l-.093-.03c.192-.316.165-.877.075-1.227Zm-.629-.083.351.047c.056.31.019.846-.167 1.152l-.408-.126c.179-.259.263-.792.224-1.073Zm-.732-.094.426.053c.042.249-.037.778-.198 1.031l-.434-.133c.174-.244.236-.674.206-.951Zm-1.724-.121c-.198.068-.286-.085-.278-.214.389-.151.562-.054.676.023.104.07.192.268.332.393-.026.197-.07.391-.13.58-.397-.109-.417-.482-.27-.709-.082-.103-.17-.13-.33-.073Zm-.278.825s.119.053.269.065c-.017.087-.081.17-.183.147-.085-.02-.122-.128-.086-.212Zm-.391-1.212c-.098-.07-.055-.222.054-.222.12.003.28.147.437.219 0 0-.413.06-.491.003Zm.404.88c.086.088.343.055.343.055l.01.055c-.113.159-.425.087-.353-.11Zm.346-.18c-.184.077-.373-.029-.315-.155.086.083.324.04.324.04l-.009.114Zm.272-2.28-.353 1.366.12-2.204.546-.497.278.65-.702 2.14.186-1.44c.017-.103-.06-.115-.075-.015Zm.025 1.657s.393-.02.504.024c.08.037.026.183-.08.166-.111-.015-.424-.19-.424-.19Zm.616.331.427.056c.033.25-.028.671-.18.907l-.414-.128c.11-.277.136-.538.167-.835Zm6.902 6.063c0 1.056-.459 1.858-1.222 2.303l.272-.591h-.265l-.351.756c-.394.155-.811.232-1.23.228-1.393 0-1.76.06-2.275.606-.517-.547-.886-.606-2.276-.606a3.265 3.265 0 0 1-1.226-.224h.01l.35-.76h-.263l-.309.666a2.447 2.447 0 0 1-.212-.12l.252-.546h-.262l-.187.407c-.596-.467-.947-1.197-.947-2.119v-3.32h10.137v3.32h.004ZM21.98 13.2c-.158.434-.285.907-.285 1.378v5.062h-.554c-.25-.26-.462-1.122-.462-1.122-.138.31.02.94.166 1.122h-.713c-.176-.254-.33-1.154-.33-1.154-.213.26-.077.958.056 1.154h-.475c-.03-.36.067-.752.067-.752-.248-.048-.512-.188-.51-.48.125.125.176.123.35.12l.2-.17c-.666.024-.698-.756-.167-1.121-.53.018-.925-.317-.732-.915-.376-.208-.509-.884-.232-1.181-.2-.233-.233-.69-.106-1-.266 0-.566-.113-.733-.307-.012.007-.029.011-.042.017.334-.145.616-.37.807-.65h3.695V13.2Zm-2.02-2.437c-.548.102-1.021.817-1.409 1.463l-.043.074h-.414l-.001.076c-.043.499-.488 1.174-1.466 1.174-.453 0-.795-.147-1.029-.349a1.296 1.296 0 0 1-.393-.6 1.063 1.063 0 0 1-.043-.224l-.004-.076h-.41l-.044-.075c-.389-.644-.862-1.36-1.41-1.463l1.497-.924 1.838 1.062 1.835-1.062 1.496.924Zm-1.712-1.38-1.466.82V6.888l1.99-.721-.524 3.216Zm-1.62-2.857-2.177-.915c.184-.464 1.037-.86 2.177-.86 1.137 0 1.99.396 2.174.86l-2.174.915Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.466 16.472.005-.255c-.732-.017-.9-.935-.9-.935-.215.675.343 1.18.895 1.19Zm-.924 1.555-.073-.241c-.624.169-.948-.883-.948-.883-.199.765.497 1.306 1.02 1.124Zm.433-.976c-.745.126-1.05-.797-1.05-.797-.083.503.222 1.013.717 1.066-.112.655.46.992.956.758l-.071-.229c-.43.154-.836-.299-.552-.798Zm-.445-2.634.005-.254c-.983-.216-.901-.937-.901-.937-.212.68.346 1.18.896 1.19Zm-6.239 10.55-.352.761h.265l.35-.76h-.263Zm.533 0-.351.761h.266l.348-.76h-.263Zm2.131 0-.351.761h.264l.352-.76h-.265Zm.533 0-.354.761h.267l.35-.76h-.263Zm-1.066 0-.352.761h.265l.351-.76h-.264Zm3.114.761h.265l.351-.76h-.265l-.351.76Zm-4.18-.76-.35.76h.265l.351-.76h-.265Zm.532 0-.351.76h.266l.351-.76h-.266Zm-1.205-4.087c-.049 0-.09.05-.09.115 0 .063.041.114.09.114.05 0 .093-.051.093-.114-.001-.065-.043-.114-.093-.114ZM16.63 3.724c1.092 0 1.967.386 2.45.799 0 0 .145-.923.633-1.733l-.88.104-.46-1.042-.885.49-.858-.907-.859.907-.887-.49-.46 1.042-.88-.104c.49.81.633 1.733.633 1.733.483-.413 1.36-.799 2.453-.799Zm-2.056-.414.42-.947.777.44.859-.901.858.902.777-.44.415.946.516-.084c-.135.26-.244.534-.324.818-.565-.35-1.404-.62-2.242-.62-.841 0-1.68.27-2.244.62a4.327 4.327 0 0 0-.326-.818l.514.084Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.527 1.86a.226.226 0 0 0 .17-.057.255.255 0 0 0 .083-.168c.012-.136-.175-.498-.175-.498s-.279.32-.288.457a.26.26 0 0 0 .054.179.23.23 0 0 0 .156.088Zm1.442.557a.221.221 0 0 0 .257-.03.244.244 0 0 0 .056-.075c.063-.12.022-.53.022-.53s-.37.178-.431.3a.265.265 0 0 0-.016.188.249.249 0 0 0 .112.147Zm-3.241-.556a.23.23 0 0 0 .159-.087.26.26 0 0 0 .055-.18c-.013-.137-.289-.457-.289-.457s-.186.363-.175.498a.252.252 0 0 0 .081.168.223.223 0 0 0 .169.058Zm-1.44.556a.247.247 0 0 0 .113-.147.264.264 0 0 0-.016-.188c-.06-.122-.432-.3-.432-.3s-.04.41.023.53a.24.24 0 0 0 .136.122.217.217 0 0 0 .176-.017Zm17.297 8.431c.306-.116.544-.428.663-.716-.782-.12-2.86-1.048-4.565-.293.639-.646 1.213-.729 1.268-1.658.265.202.712.317.965-.166-.176-.553-.621-.105-.683-.257-.087-.213.56.064.7-.654-.505-.184-.654.254-.745.152-.083-.096.32-.28.023-.859-.524.327-.25.693-.362.735-.134.057-.028-.394-.609-.372-.057.662.545.684.447.789-.12.127-.276-.381-.715-.123.008.534.416.828.835.702-.069 1.016-.946.827-1.598 1.972 1.383.753 2.009 2.068 2.86 2.977.28-.212.76-1.155.76-1.155.92.758 1.569.003 1.569.003-.317-.345-.33-.607-.813-1.077Zm-1.343.184c.096.224.284 1.006-.166 1.602-.514-1.09-1.219-2.025-1.79-2.428-.125-.086.069-.237.421-.288 1.063-.213 2.31.265 2.903.433-.277.218-.502.318-.784.354.43.385.746.71.967 1.072-.416.112-.652-.169-1.55-.745Zm-8.876 16.953v-1.241c-.902.44-2.05.797-3.525.937l-.067.443c.125.02.284.035.496.05-.546.08-1.253.118-1.64.118-.388 0-1.093-.038-1.641-.118.21-.015.369-.03.494-.05l-.067-.442c-1.476-.141-2.624-.499-3.524-.938v1.241l-1.224.535c.907.501 1.95.91 3.154 1.24l-.144.519c.69.215 1.792.434 2.95.434 1.155 0 2.257-.22 2.948-.434l-.142-.52c1.204-.33 2.249-.739 3.155-1.24l-1.223-.534Zm-10.044.563.825-.354v-1.01c.53.217 1.227.443 2.226.664l-.47 1.621a13.084 13.084 0 0 1-2.581-.921Zm5.307 1.869c-.932 0-1.842-.148-2.619-.352l.495-1.702c.328.082 1.148.188 2.124.188.976 0 1.792-.108 2.121-.188l.497 1.702c-.857.227-1.736.345-2.618.352Zm2.725-.948-.468-1.621c1-.22 1.695-.447 2.225-.665v1.011l.825.354c-.698.337-1.561.671-2.582.921ZM2.428 11.922s.48.943.76 1.155c.852-.908 1.479-2.222 2.86-2.977-.654-1.145-1.531-.953-1.596-1.972.42.126.825-.17.835-.702-.44-.257-.597.254-.716.123-.098-.108.503-.127.447-.789-.58-.02-.474.429-.61.372-.11-.042.163-.41-.362-.735-.295.58.11.763.025.86-.09.1-.242-.336-.744-.153.136.718.786.442.698.654-.062.152-.505-.296-.68.257.25.485.699.37.963.168.056.93.629 1.009 1.27 1.656-1.708-.755-3.785.172-4.57.294.12.287.357.6.665.712-.484.475-.496.737-.813 1.08 0 0 .646.755 1.568-.003Zm-.968-.143c.223-.362.537-.689.97-1.072-.283-.038-.506-.137-.784-.357.595-.167 1.843-.647 2.907-.432.35.05.546.202.418.288-.57.404-1.277 1.338-1.791 2.428-.45-.596-.259-1.376-.167-1.6-.898.574-1.131.855-1.553.745Zm14.421-.549v.546c.177-.227.52-.183.52-.183v.789s-.013.388-.14.554H17c-.13-.166-.14-.554-.14-.554v-.787s.341-.045.518.182v-.546H15.88Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M45.723 14.21V7.808h3.55v-2.33h-9.68v2.33h3.547v6.402h2.583Zm7.081-3.65V5.478h-2.498v8.732h2.205l4.306-5.082v5.082h2.497V5.478H57.11l-4.306 5.082Zm14.912.403v3.246h2.498v-8.73h-2.498v3.192h-4.013V5.478h-2.498v8.732h2.498v-3.247h4.013Zm9.453 3.247c.569 0 1.085-.055 1.568-.202 1.292-.386 2.135-1.504 2.135-3.027 0-1.449-.723-2.458-1.877-2.916-.55-.22-1.206-.239-1.826-.239h-2.566V5.48h-2.498v8.73h5.064Zm-.43-4.33c.344 0 .672 0 .964.11.414.147.654.514.654.955.003.219-.056.434-.17.617a1.05 1.05 0 0 1-.467.41c-.275.128-.55.128-.981.128h-2.136V9.88h2.136Zm8.612 1.027 2.98 3.303h3.323l-4.15-4.55L91.5 5.479h-3.135l-3.014 3.284h-.69V5.478h-2.497v8.732h2.497v-3.302h.69Z",
    fill: "#333"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M96.794 5.24c-3.36 0-5.374 2.018-5.374 4.622 0 2.605 2.015 4.623 5.374 4.623 3.341 0 5.356-2.018 5.356-4.623 0-2.604-2.015-4.622-5.356-4.622Zm0 7.117c-1.671 0-2.74-1.064-2.74-2.495 0-1.43 1.069-2.476 2.74-2.476 1.653 0 2.738 1.046 2.738 2.476s-1.085 2.495-2.738 2.495Zm13.674-7.374h-2.498v.88c-3.135.075-5.012 1.486-5.012 3.98 0 2.495 1.877 3.797 5.012 3.871v.88h2.498v-.88c3.152-.074 5.029-1.376 5.029-3.87 0-2.495-1.877-3.906-5.029-3.98v-.881Zm-2.498 6.86c-1.722-.073-2.48-.825-2.48-2 0-1.173.758-2.017 2.48-2.09v4.09Zm2.498-4.09c1.739.073 2.48.917 2.48 2.09 0 1.174-.741 1.927-2.48 2v-4.09Zm13.338-2.77h-2.497v.88c-3.135.075-5.013 1.486-5.013 3.98 0 2.495 1.878 3.797 5.013 3.871v.88h2.497v-.88c3.152-.074 5.03-1.376 5.03-3.87 0-2.495-1.878-3.906-5.03-3.98v-.881Zm-2.497 6.86c-1.722-.073-2.481-.825-2.481-2 0-1.173.759-2.017 2.481-2.09v4.09Zm2.497-4.09c1.74.073 2.481.917 2.481 2.09 0 1.174-.741 1.927-2.481 2v-4.09ZM41.367 24.785h.49l2.118 2.343h2.363l-2.95-3.229 2.84-2.967H44l-2.143 2.33h-.49v-2.33h-1.775v6.196h1.776v-2.343Zm7.973.078.845-2.5h.135l.844 2.5H49.34Zm-.44 1.366h2.693l.343.899h1.996l-2.388-6.196h-2.596l-2.387 6.196h2.008l.33-.899Zm10.6-2.837h1.897c-.257-1.536-1.542-2.63-3.575-2.63-2.326-.026-3.759 1.406-3.759 3.28 0 1.849 1.433 3.28 3.76 3.28 2.056-.012 3.292-1.093 3.562-2.642h-1.873c-.183.703-.833 1.185-1.739 1.185-1.138 0-1.836-.807-1.836-1.822 0-1.016.698-1.81 1.836-1.81.906 0 1.543.469 1.728 1.158l-.002.001Zm7.927 0h1.898c-.258-1.536-1.543-2.63-3.576-2.63-2.326-.026-3.759 1.406-3.759 3.28 0 1.849 1.434 3.28 3.76 3.28 2.056-.012 3.293-1.093 3.563-2.642h-1.875c-.184.703-.832 1.185-1.738 1.185-1.14 0-1.837-.807-1.837-1.822 0-1.016.698-1.81 1.837-1.81.906 0 1.542.469 1.726 1.158v.001Zm4.87 1.47.845-2.499h.135l.845 2.5h-1.825Zm-.44 1.367h2.694l.342.899h1.996l-2.388-6.196h-2.596l-2.387 6.196h2.008l.33-.899Z",
    fill: "#333"
  }))), tinkoff_defs || (tinkoff_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "tinkoff_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h129v32H0z"
  })))));
};
/* harmony default export */ var tinkoff = (SvgTinkoff);
;// CONCATENATED MODULE: ./components/form/select.tsx


function select_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var select_ref2 =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

var select_ref3 =  true ? {
  name: "14o5m2r",
  styles: "padding:12px 0"
} : 0;

var select_ref4 =  true ? {
  name: "5qh46b",
  styles: "height:34px;border-bottom:1px solid #DCDEDA;cursor:pointer;display:flex;justify-content:space-between"
} : 0;

var select_ref5 =  true ? {
  name: "1l8lj3s",
  styles: "color:#BDBFBB"
} : 0;

var select_ref6 =  true ? {
  name: "1aynuae",
  styles: "width:20px;height:20px"
} : 0;

var select_ref7 =  true ? {
  name: "xbe8xg",
  styles: "height:34px;cursor:pointer;color:#BDBFBB;display:flex;justify-content:space-between"
} : 0;

var select_ref8 =  true ? {
  name: "1aynuae",
  styles: "width:20px;height:20px"
} : 0;

var select_ref9 =  true ? {
  name: "v5la8f",
  styles: "display:flex;flex-direction:column;button{width:calc(100% + 60px);height:34px;text-align:start;margin:0 -30px;padding:0 30px;&:hover{background:#e0e0de;}}"
} : 0;

function TimeSelect(_ref) {
  var options = _ref.options,
      value = _ref.value,
      setValue = _ref.setValue;

  var _useState = (0,react.useState)(false),
      showOptions = _useState[0],
      setShowOptions = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: select_ref2,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: select_ref3,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: select_ref4,
        onClick: function onClick() {
          return setShowOptions(function (prev) {
            return !prev;
          });
        },
        children: [!(value !== null && value !== void 0 && value.length) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: select_ref5,
          children: "\u0412\u0440\u0435\u043C\u044F"
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: value
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
          css: select_ref6,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
            xlinkHref: "#clock-booking"
          })
        })]
      })
    }), showOptions && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        width: 'calc(100% + 60px)',
        position: 'absolute',
        top: 0,
        marginLeft: -30,
        marginRight: -30,
        padding: '12px 30px 6px',
        background: '#f6f6f5',
        zIndex: 99
      },  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: select_ref7,
        onClick: function onClick() {
          return setShowOptions(function (prev) {
            return !prev;
          });
        },
        children: ["\u0412\u0440\u0435\u043C\u044F", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
          css: select_ref8,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
            xlinkHref: "#clock-booking"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: select_ref9,
        children: options === null || options === void 0 ? void 0 : options.map(function (option) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
            type: "button",
            onClick: function onClick() {
              setValue(option);
              setShowOptions(false);
            },
            children: option || 'Весь день'
          }, option);
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./utils/validators.js
var validators = __webpack_require__(8710);
// EXTERNAL MODULE: ./providers/authorization.tsx + 4 modules
var authorization = __webpack_require__(4401);
;// CONCATENATED MODULE: ./components/booking-form/index.model.ts

 // only clean functions

function isSurnameFieldRequired(_ref) {
  var type = _ref.type,
      reservation_type = _ref.reservation_type,
      certificate_last_name_required = _ref.certificate_last_name_required,
      reservation_by_name_only = _ref.reservation_by_name_only;

  if (type === models_action/* ACTION_TYPES.FREE */.aI.FREE) {
    return false;
  }

  if (type === models_action/* ACTION_TYPES.certificate */.aI.certificate && certificate_last_name_required) {
    return true;
  }

  if (type === models_action/* ACTION_TYPES.reservation */.aI.reservation && !reservation_by_name_only && reservation_type === models_action/* RESERVATION_TYPES.full */.x5.full) {
    return true;
  }

  return false;
}
function isPhoneFieldRequired(_ref2) {
  var type = _ref2.type;

  // TODO а что с purchase?
  if (type === models_action/* ACTION_TYPES.FREE */.aI.FREE) {
    return false;
  }

  return true;
}
function isDateRequired(_ref3) {
  var isCertificateTypeWithOpenDate = _ref3.isCertificateTypeWithOpenDate,
      shortReservation = _ref3.shortReservation;

  if (isCertificateTypeWithOpenDate || shortReservation) {
    return false;
  }

  return true;
}
function categoriesForSelectedDate(_ref4) {
  var selectedDate = _ref4.selectedDate,
      time = _ref4.time,
      eventDates = _ref4.eventDates,
      action = _ref4.action,
      isCertificateTypeWithOpenDate = _ref4.isCertificateTypeWithOpenDate;

  if (isCertificateTypeWithOpenDate) {
    return action.event_categories.filter(function (category) {
      return category.status !== models_action/* CATEGORIES_STATUS.CLOSE_HIDDEN */.jL.CLOSE_HIDDEN;
    });
  }

  if (!selectedDate || !(eventDates !== null && eventDates !== void 0 && eventDates.length) || time === '') {
    return [];
  }

  var timeFilter = time === null ? function (item) {
    return item.time.length === 0;
  } : function (item) {
    return item.time.includes(luxon/* DateTime.fromFormat */.ou.fromFormat(time, 'T').toFormat('TT'));
  };
  var categoriesIds = eventDates.filter(timeFilter).map(function (item) {
    return item.quotas;
  }).flat().map(function (quota) {
    return quota.category.id;
  });
  return action.event_categories.filter(function (cat) {
    return categoriesIds.includes(cat.id);
  });
}
function eventDateForCurrentDate(_ref5) {
  var eventDates = _ref5.eventDates,
      time = _ref5.time;

  if (!(eventDates !== null && eventDates !== void 0 && eventDates.length)) {
    return undefined;
  }

  if (eventDates.length === 1) {
    return eventDates[0];
  }

  var timeFilter = time === null ? function (item) {
    return item.time.length === 0;
  } : function (item) {
    return item.time.includes(luxon/* DateTime.fromFormat */.ou.fromFormat(time, 'T').toFormat('TT'));
  };
  return eventDates.find(timeFilter);
}
function quotaForSelectedDateByCategoryId(categoryId, currentEventDate) {
  if (currentEventDate) {
    var dateQuota = currentEventDate.quotas.find(function (quota) {
      return quota.category.id === categoryId;
    });

    if (dateQuota) {
      return {
        remainder: dateQuota.remainder,
        status: dateQuota.status
      };
    }
  }

  return {};
}
var QUOTA_REMAINDER_TYPES = {
  noTickets: 'Билетов не осталось'
};
// EXTERNAL MODULE: ./providers/seo-analytics/index.tsx
var seo_analytics = __webpack_require__(5165);
;// CONCATENATED MODULE: ./public/img/plus.png
/* harmony default export */ var plus = ({"src":"/_next/static/media/plus.6c6def1d.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEW9v7u9v7q8v7u8v7q9vrq8vru8vrq9v7q8v7q9vrq9v7u9v7q9v7q8v7u8v7q9vrq8vrq9v7u8v7u8v7u8v7q9v7u9v7q8v7u8vrq9v7u8v7unqIpXAAAAG3RSTlMAAAAAAAAABAQECAiRkZGRkZaWl5ekpKSk29tfC/3oAAAAQ0lEQVR42iXKWQ6AIBAE0R5oHRRwZVy4/0Eh4a+SepgXyTvVI0S8hqjAxOukA7KV+hfbRtyWIA5jhVW+hx17lSNRpQFh1QKxLG2YbQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/minus.png
/* harmony default export */ var minus = ({"src":"/_next/static/media/minus.73e9d969.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAHlBMVEW9v7u8v7u9vrq8vrq9vrq8vrq9v7u8v7u9v7u8v7s5TSBbAAAACnRSTlMAAAAABASRkZ+iKp38qQAAAC5JREFUeNpjYBBgFGQIdXFxYTBWNjJiqOzomA4ipjEYGykpMYSGuLowMAgwCgIApCMIOg5kXXwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./lib/api/browserStorage.ts
var browserStorage = __webpack_require__(6343);
// EXTERNAL MODULE: ./components/form/phone-input.tsx
var phone_input = __webpack_require__(9732);
;// CONCATENATED MODULE: ./components/booking-form/index.tsx






function booking_form_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function booking_form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function booking_form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? booking_form_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : booking_form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







 // eslint-disable-next-line import/no-extraneous-dependencies

































yup_index_esm/* addMethod */.kM(yup_index_esm/* string */.Z_, 'email', validators/* emailValidator */.Le);
yup_index_esm/* addMethod */.kM(yup_index_esm/* string */.Z_, 'phone', validators/* phoneValidator */.tH);
var validationSchema = yup_index_esm/* object */.Ry().shape({
  name: yup_index_esm/* string */.Z_().required('Обязательное поле'),
  surname: yup_index_esm/* string */.Z_().when('action', {
    is: function is(value) {
      return isSurnameFieldRequired(value);
    },
    then: function then(schema) {
      return schema.required('Обязательное поле');
    }
  }),
  email: yup_index_esm/* string */.Z_().required('Обязательное поле').email(),
  phone: yup_index_esm/* string */.Z_().when('action', {
    is: function is(value) {
      return isPhoneFieldRequired(value);
    },
    then: function then(schema) {
      return schema.required('Обязательное поле').min(10, 'Неправильно введён телефон').max(20, 'Неправильно введён телефон') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      .phone();
    }
  })
});

var booking_form_ref3 =  true ? {
  name: "1avcwmd",
  styles: "font-weight:800;line-height:1.39"
} : 0;

var booking_form_ref4 =  true ? {
  name: "fapids",
  styles: "font-size:14px;font-weight:500;line-height:1.43"
} : 0;

var booking_form_ref5 =  true ? {
  name: "wjmdz",
  styles: "text-align:center;height:125px"
} : 0;

var booking_form_ref6 =  true ? {
  name: "1bc54tk",
  styles: "padding:1em 0 2em;p{font-size:14px;font-weight:400;margin-bottom:24px;}"
} : 0;

var booking_form_ref7 =  true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0;

var booking_form_ref8 =  true ? {
  name: "1avcwmd",
  styles: "font-weight:800;line-height:1.39"
} : 0;

var booking_form_ref9 =  true ? {
  name: "fapids",
  styles: "font-size:14px;font-weight:500;line-height:1.43"
} : 0;

var booking_form_ref10 =  true ? {
  name: "1aynuae",
  styles: "width:20px;height:20px"
} : 0;

var booking_form_ref11 =  true ? {
  name: "1m3nvfu",
  styles: "font-size:26px;font-weight:700;font-family:Montserrat;color:#282828"
} : 0;

var booking_form_ref12 =  true ? {
  name: "mfifhn",
  styles: "border:none;height:75vh;width:100%"
} : 0;

var booking_form_ref13 =  true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0;

var booking_form_ref14 =  true ? {
  name: "3w0yoi",
  styles: "display:flex;flex-direction:column;gap:8px"
} : 0;

var booking_form_ref15 =  true ? {
  name: "94p30n",
  styles: "display:flex;justify-content:space-between;border-bottom:1px solid #DCDEDA;height:34px;cursor:pointer;position:relative"
} : 0;

var booking_form_ref16 =  true ? {
  name: "1l8lj3s",
  styles: "color:#BDBFBB"
} : 0;

var booking_form_ref17 =  true ? {
  name: "9yob6c",
  styles: "width:20px;height:20px;fill:#f44336"
} : 0;

var booking_form_ref19 =  true ? {
  name: "1qkv1ao",
  styles: "padding:8px;background:#F8F8F8;margin-top:12px;border-radius:4px"
} : 0;

var booking_form_ref20 =  true ? {
  name: "1ajlddi",
  styles: "color:#BFC1C3;font-size:12px;line-height:130%"
} : 0;

var booking_form_ref21 =  true ? {
  name: "1qvid8u",
  styles: "color:#282828;padding-right:8px;line-height:160%;margin-top:2px"
} : 0;

var booking_form_ref22 =  true ? {
  name: "xda5ep",
  styles: "margin-top:12px"
} : 0;

var booking_form_ref23 =  true ? {
  name: "muir5",
  styles: "color:#282828"
} : 0;

var booking_form_ref24 =  true ? {
  name: "1a6f5dh",
  styles: "display:flex;justify-content:flex-end;align-items:center;gap:15px;height:28px;margin-left:auto"
} : 0;

var booking_form_ref25 =  true ? {
  name: "39jrzv",
  styles: "display:flex;align-items:center;gap:4px;color:#7D7B7A;button{width:28px;height:28px;background-size:16px;background-position:50%;background-repeat:no-repeat;color:#BFC1C3;}"
} : 0;

var booking_form_ref26 =  true ? {
  name: "1xnt49x",
  styles: "display:flex;align-items:center;gap:8px;margin-top:12px"
} : 0;

var _ref27 =  true ? {
  name: "17lrmpa",
  styles: "width:12px"
} : 0;

var _ref28 =  true ? {
  name: "eh8qfe",
  styles: "font-size:12px;font-weight:400;font-family:Golos;color:#282828;padding-top:6px;b{font-weight:bolder;}"
} : 0;

var _ref29 =  true ? {
  name: "yz1nei",
  styles: "margin-top:16px"
} : 0;

var _ref30 =  true ? {
  name: "1ap4k4s",
  styles: "font-size:18px;font-weight:700;font-family:Montserrat;color:#282828"
} : 0;

var _ref31 =  true ? {
  name: "1nrbqpy",
  styles: "font-size:12px;font-weight:400;color:#7D7B7A"
} : 0;

var _ref32 =  true ? {
  name: "9przm0",
  styles: "margin-top:35px;margin-bottom:14px;display:flex;flex-direction:column;gap:10px;font-size:14px;color:#7D7B7A;p{display:flex;align-items:center;gap:8px;}"
} : 0;

var _ref33 =  true ? {
  name: "19c4s80",
  styles: "width:20px;height:8px;fill:#fff"
} : 0;

var _ref34 =  true ? {
  name: "hibdix",
  styles: "width:20px;height:20px;fill:#fff"
} : 0;

var _ref35 =  true ? {
  name: "hibdix",
  styles: "width:20px;height:20px;fill:#fff"
} : 0;

var _ref36 =  true ? {
  name: "1v8kky6",
  styles: "padding:21px 0"
} : 0;

var _ref37 =  true ? {
  name: "b8uqu5",
  styles: "color:#7D7B7A;text-align:center;padding:14px 0;a{text-decoration:underline;&:hover{text-decoration:none;}}"
} : 0;

var _ref38 =  true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0;

var _ref39 =  true ? {
  name: "z4ghv5",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;background:linear-gradient(110deg, #fff 8%, #ececec 18%, #fff 33%);border-radius:5px;background-size:200% 100%;animation:1.5s shine linear infinite;opacity:0.5;z-index:99999"
} : 0;

var _ref40 =  true ? {
  name: "13h8rix",
  styles: "width:100%;max-width:125px;height:16px"
} : 0;

function BookingForm(_ref) {
  var _errors$name, _errors$surname, _errors$phone, _errors$email, _eventDateForCurrentD;

  var setModalState = _ref.setModalState,
      actionData = _ref.actionData,
      _ref$paymentData = _ref.paymentData,
      paymentData = _ref$paymentData === void 0 ? null : _ref$paymentData,
      _ref$isPayment = _ref.isPayment,
      isPayment = _ref$isPayment === void 0 ? false : _ref$isPayment,
      _ref$bankSelectProp = _ref.bankSelectProp,
      bankSelectProp = _ref$bankSelectProp === void 0 ? false : _ref$bankSelectProp,
      gbReccomendLink = _ref.gbReccomendLink,
      currentCity = _ref.currentCity,
      banOnSomeEmails = _ref.banOnSomeEmails,
      banEmails = _ref.banEmails;
  var router = (0,next_router.useRouter)();
  var seoAnalytics = (0,seo_analytics/* useSeoAnalytics */.$)();

  var _useForm = (0,index_esm/* useForm */.cI)({
    defaultValues: {
      name: '',
      surname: '',
      phone: '',
      email: '',
      action: actionData
    },
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    mode: 'onChange'
  }),
      register = _useForm.register,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isValid = _useForm$formState.isValid,
      control = _useForm.control,
      watch = _useForm.watch,
      setError = _useForm.setError,
      setValue = _useForm.setValue,
      reset = _useForm.reset;

  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  var shortReservation = actionData.type === models_action/* ACTION_TYPES.reservation */.aI.reservation && actionData.reservation_type === models_action/* RESERVATION_TYPES.shortened */.x5.shortened;
  var isCertificateTypeWithOpenDate = actionData.with_open_date && actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate;

  var _useState = (0,react.useState)(''),
      bank = _useState[0],
      setBank = _useState[1];

  var _useState2 = (0,react.useState)(bankSelectProp),
      bankSelect = _useState2[0],
      showBankSelect = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      smartbiletLoadStatus = _useState3[0],
      setSmartbiletLoadStatus = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      widgetSrc = _useState4[0],
      setWidgetSrc = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      time = _useState5[0],
      setTime = _useState5[1];

  var _useState6 = (0,react.useState)(true),
      check = _useState6[0],
      setCheck = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      calendarOpen = _useState7[0],
      setCalendarOpen = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      selectedDate = _useState8[0],
      setSelectedDate = _useState8[1];

  var _useState9 = (0,react.useState)(undefined),
      permittedDates = _useState9[0],
      setPermittedDates = _useState9[1];

  var _useState10 = (0,react.useState)(undefined),
      eventDates = _useState10[0],
      setEventDates = _useState10[1];

  var _useState11 = (0,react.useState)({}),
      orderTickets = _useState11[0],
      setOrderTickets = _useState11[1];

  var auth = (0,authorization/* useAuthorization */.o)();
  (0,react.useEffect)(function () {
    // checking for excluded emails
    var subscription = watch(function (value, _ref2) {
      var name = _ref2.name;

      if (name === 'email' && value.email && value.email.length > 0) {
        if (banOnSomeEmails && banEmails && banEmails.value && typeof banEmails.value === 'string') {
          var _ret = function () {
            var banEmailsArr = banEmails.value.split(' ');

            var _loop = function _loop(i) {
              if (value.email.includes("@".concat(banEmailsArr[i]))) {
                return {
                  v: {
                    v: setTimeout(function () {
                      setError('email', {
                        message: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0443\u044E \u043F\u043E\u0447\u0442\u0443, \u043D\u0430 @".concat(banEmailsArr[i], " \u0431\u0438\u043B\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u043D\u0435 \u043F\u0440\u0438\u0439\u0442\u0438")
                      });
                    })
                  }
                };
              }
            };

            for (var i = 0; i < banEmailsArr.length; i += 1) {
              var _ret2 = _loop(i);

              if (typeof _ret2 === "object") return _ret2.v;
            }
          }();

          if (typeof _ret === "object") return _ret.v;
        }
      }

      return null;
    });
    return function () {
      return subscription.unsubscribe();
    };
  }, [watch, banOnSomeEmails, banEmails]);

  var getDates = function getDates() {
    if (selectedDate) {
      var date = luxon/* DateTime.fromFormat */.ou.fromFormat(selectedDate, 'dd.LL.yyyy').toFormat('yyyy-LL-dd');
      return [date, date];
    }

    return null;
  };

  function getTicketsCountText(category) {
    var selectedEventDate = eventDateForCurrentDate({
      eventDates: eventDates,
      time: time
    });

    var categoryItem = booking_form_objectSpread(booking_form_objectSpread({}, category), quotaForSelectedDateByCategoryId(category.id, selectedEventDate)); // eslint-disable-next-line consistent-return


    if (categoryItem.status === models_action/* CATEGORIES_STATUS.CLOSE_VISIBLE */.jL.CLOSE_VISIBLE) return ''; // eslint-disable-next-line consistent-return

    if (!categoryItem.show_remainder) return ''; // eslint-disable-next-line consistent-return

    if (categoryItem.buy_form_text) return categoryItem.buy_form_text;
    var count = categoryItem === null || categoryItem === void 0 ? void 0 : categoryItem.remainder;

    if (count >= 100 || categoryItem.is_unlimited) {
      // eslint-disable-next-line consistent-return
      return 'Осталось больше <b>100</b> билетов';
    }

    if (count === 0) {
      // eslint-disable-next-line consistent-return
      return QUOTA_REMAINDER_TYPES.noTickets;
    } // eslint-disable-next-line consistent-return


    return "\n        ".concat((0,word_declension/* default */.Z)(count, 'Остался', 'Осталось', 'Осталось'), "\n    <b>").concat(count, "</b> ").concat((0,word_declension/* default */.Z)(count, 'билет', 'билета', 'билетов'));
  }

  var decreaseItem = function decreaseItem(category) {
    var selectedEventDate = eventDateForCurrentDate({
      eventDates: eventDates,
      time: time
    });

    var categoryItem = booking_form_objectSpread(booking_form_objectSpread({}, category), quotaForSelectedDateByCategoryId(category.id, selectedEventDate));

    if (categoryItem.status === models_action/* CATEGORIES_STATUS.CLOSE_VISIBLE */.jL.CLOSE_VISIBLE) {
      return;
    }

    if (!orderTickets[categoryItem.id] || orderTickets[categoryItem.id] === 0) {
      return;
    }

    if (orderTickets[categoryItem.id]) {
      setOrderTickets(function (prev) {
        return booking_form_objectSpread(booking_form_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, categoryItem.id, prev[categoryItem.id] - 1));
      });
    }
  };

  var increaseItem = function increaseItem(category) {
    var selectedEventDate = eventDateForCurrentDate({
      eventDates: eventDates,
      time: time
    });

    var categoryItem = booking_form_objectSpread(booking_form_objectSpread({}, category), quotaForSelectedDateByCategoryId(category.id, selectedEventDate));

    if (selectedEventDate) {
      var dateQuota = selectedEventDate.quotas.find(function (quota) {
        return quota.category.id === category.id;
      });

      if (dateQuota) {
        categoryItem.remainder = dateQuota.remainder;
        categoryItem.status = dateQuota.status;
      }
    }

    if (categoryItem.status === models_action/* CATEGORIES_STATUS.CLOSE_VISIBLE */.jL.CLOSE_VISIBLE) {
      return;
    }

    var maxCountArray = [actionData.max_count_per_user];

    if (!categoryItem.is_unlimited) {
      maxCountArray.push(categoryItem.remainder);
    }

    var maxCount = Math.min.apply(Math, maxCountArray);

    if (maxCount === 0) {
      return;
    }

    if (orderTickets[categoryItem.id] === maxCount) {
      return;
    }

    if (orderTickets[categoryItem.id]) {
      setOrderTickets(function (prev) {
        return booking_form_objectSpread(booking_form_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, categoryItem.id, prev[categoryItem.id] + 1));
      });
    } else {
      setOrderTickets(function (prev) {
        return booking_form_objectSpread(booking_form_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, categoryItem.id, 1));
      });
    }
  };

  var serviceCoefficient = function serviceCoefficient() {
    return (Number(actionData.cerificate_service_fee) + 100) / 100;
  };

  var onSubscribe = function onSubscribe(valuesData) {
    if (check) {
      var subscriptionsData = {
        first_name: valuesData.first_name,
        last_name: valuesData.last_name,
        email: valuesData.email,
        phone_number: valuesData.phone_number,
        source: 'actionReservation',
        city: currentCity.remote_id,
        event_id: actionData.id
      };

      if (valuesData.last_name) {
        subscriptionsData.last_name = valuesData.last_name;
      }

      if (valuesData.phone_number) {
        subscriptionsData.phone_number = valuesData.phone_number;
      }

      http/* http.post */.d.post(urls.V2.subscriptions, subscriptionsData);
    }
  };

  function onSubmit() {
    var _watch = watch(),
        name = _watch.name,
        phone = _watch.phone,
        email = _watch.email,
        surname = _watch.surname;

    var activeIndex = actionData.event_categories.findIndex(function (category) {
      return category.is_active;
    });
    var data = paymentData || {
      event: actionData.id,
      count_by_category: shortReservation ? actionData.event_categories.map(function (_item, index) {
        if (index === activeIndex) {
          return {
            category: _item.id,
            count: 1
          };
        }

        return null;
      }).filter(function (item) {
        return item !== null;
      }) : actionData.event_categories.map(function (item) {
        if (orderTickets[item.id]) {
          return {
            category: item.id,
            count: orderTickets[item.id]
          };
        }

        return null;
      }).filter(function (item) {
        return item !== null;
      }),
      time: isDateRequired({
        isCertificateTypeWithOpenDate: isCertificateTypeWithOpenDate,
        shortReservation: shortReservation
      }) ? time : null,
      email: email,
      first_name: name,
      date: isDateRequired({
        isCertificateTypeWithOpenDate: isCertificateTypeWithOpenDate,
        shortReservation: shortReservation
      }) ? luxon/* DateTime.fromFormat */.ou.fromFormat(selectedDate, 'dd.LL.yyyy').toFormat('yyyy-LL-dd') : null
    };

    if (isSurnameFieldRequired(actionData) && !(paymentData !== null && paymentData !== void 0 && paymentData.last_name)) {
      data.last_name = surname;
    }

    if (bank) {
      data.payment_bank = bank;
    }

    if (isPhoneFieldRequired(actionData)) {
      var phoneNumber = (0,parsePhoneNumber/* parsePhoneNumber */.S)((paymentData === null || paymentData === void 0 ? void 0 : paymentData.phone_number) || phone, 'RU');

      if (phoneNumber) {
        data.phone_number = phoneNumber.number.substring(1);
      }
    }

    seoAnalytics.dispatch({
      ym: ['Book_success']
    });
    onSubscribe(data);
    http/* http.post */.d.post(urls.V4.reservations, data, null, {
      contentType: 'json',
      withTokenRequest: true
    }).then(function (response) {
      (0,browserStorage/* setLocalStorageItem */.D)(models_action/* ACTION_TYPES.reservation */.aI.reservation, response.data.token);

      if (actionData.type === models_action/* ACTION_TYPES.reservation */.aI.reservation || actionData.type === models_action/* ACTION_TYPES.FREE */.aI.FREE) {
        if (response.status === 400) {
          setModalState({
            show: true,
            content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
                setModalState: setModalState,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: booking_form_ref3,
                    children: response.data[0] === events/* errorTextIfSaleIsCompleted */.Ts ? 'Продажа завершена' : 'Ошибка'
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: booking_form_ref4,
                  dangerouslySetInnerHTML: {
                    __html: response.data[0]
                  }
                })
              })]
            }),
            options: {
              width: 400
            },
            enableOutsideClick: false
          });
        } else {
          setModalState({
            show: true,
            content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
                showClose: false,
                setModalState: setModalState,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
                  children: response.data.title
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContent */.hz, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: booking_form_ref5,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                      width: 120,
                      height: 120,
                      marginLeft: -20,
                      transform: 'rotate(-20deg)',
                      fill: theme.colors.red,
                      overflow: 'hidden'
                    },  true ? "" : 0,  true ? "" : 0),
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                      xlinkHref: "#envelope"
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: booking_form_ref6,
                  dangerouslySetInnerHTML: {
                    __html: response.data.description.html
                  }
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: booking_form_ref7,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* RedButton */.QT, {
                    callback: function callback() {
                      setModalState(models_modal/* initialModalState */.L);

                      if (gbReccomendLink) {
                        router.push(gbReccomendLink);
                      }
                    },
                    children: "\u041E\u0442\u043B\u0438\u0447\u043D\u043E"
                  })
                })]
              })]
            }),
            outsideCloseCallback: function outsideCloseCallback() {
              setModalState(models_modal/* initialModalState */.L);

              if (gbReccomendLink) {
                router.push(gbReccomendLink);
              }
            }
          });
        }
      } else if (actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate) {
        if (response.status === 400) {
          setModalState({
            show: true,
            content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
                setModalState: setModalState,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: booking_form_ref8,
                    children: response.data[0] === events/* errorTextIfSaleIsCompleted */.Ts ? 'Продажа завершена' : 'Ошибка'
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: booking_form_ref9,
                  dangerouslySetInnerHTML: {
                    __html: response.data[0]
                  }
                })
              })]
            }),
            options: {
              width: 400
            },
            enableOutsideClick: false
          });
        } else {
          window.location.href = response.data.payment_url;
        }
      } else {
        setModalState(models_modal/* initialModalState */.L);
        var url = new URL(window.location.href);
        url.searchParams["delete"]('order');
        router.replace(url.href, undefined, {
          shallow: true
        });
      }
    });
  }

  var choosePayment = function choosePayment() {
    var _watch2 = watch(),
        name = _watch2.name,
        email = _watch2.email,
        surname = _watch2.surname,
        phone = _watch2.phone;

    var data = {
      event: actionData.id,
      count_by_category: actionData.event_categories.map(function (item) {
        if (orderTickets[item.id]) {
          return {
            category: item.id,
            count: orderTickets[item.id]
          };
        }

        return null;
      }).filter(function (item) {
        return item !== null;
      }),
      time: isDateRequired({
        isCertificateTypeWithOpenDate: isCertificateTypeWithOpenDate,
        shortReservation: shortReservation
      }) ? time : null,
      email: email,
      first_name: name,
      date: isDateRequired({
        isCertificateTypeWithOpenDate: isCertificateTypeWithOpenDate,
        shortReservation: shortReservation
      }) ? luxon/* DateTime.fromFormat */.ou.fromFormat(selectedDate, 'dd.LL.yyyy').toFormat('yyyy-LL-dd') : null
    };

    if (isSurnameFieldRequired(actionData)) {
      data.last_name = surname;
    }

    if (isPhoneFieldRequired(actionData)) {
      var phoneNumber = (0,parsePhoneNumber/* parsePhoneNumber */.S)(phone, 'RU');

      if (phoneNumber) {
        data.phone_number = phoneNumber.number;
      }
    }

    onSubscribe(data);
    setModalState(function (old) {
      return booking_form_objectSpread(booking_form_objectSpread({}, old), {}, {
        show: true,
        options: {
          width: 760
        },
        content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookingForm, {
          gbReccomendLink: gbReccomendLink,
          setModalState: setModalState,
          actionData: actionData,
          bankSelectProp: bankSelect,
          paymentData: data,
          isPayment: true,
          currentCity: currentCity,
          banOnSomeEmails: banOnSomeEmails,
          banEmails: banEmails
        }),
        outsideCloseCallback: function outsideCloseCallback() {
          var url = new URL(window.location.href);
          url.searchParams["delete"]('order');
          router.replace(url.href, undefined, {
            shallow: true
          });
        }
      });
    });
  };

  var getPrice = function getPrice() {
    return Object.entries(orderTickets).reduce(function (acc, cur) {
      var discount = 0;
      var eventData = actionData.event_categories.find(function (c) {
        return c.id === Number(cur[0]);
      });

      if (eventData) {
        if (eventData.discount !== null && Number(eventData.discount) !== 0) {
          discount = Number(eventData.discount);
        }

        var price = Number(eventData.price);

        if (discount) {
          price = price * (100 - discount) / 100;
        }

        return acc + price * cur[1];
      }

      return acc;
    }, 0);
  };

  var totalPrice = function totalPrice() {
    var coefficient = serviceCoefficient();
    var price = getPrice();
    return (0,utils/* splitPriceByThree */.ax)((price * coefficient).toFixed(2));
  };

  var totalServicePrice = function totalServicePrice() {
    var price = getPrice();
    return (price * serviceCoefficient() - price).toFixed(2);
  };

  var getDayTime = function getDayTime() {
    var _eventDates$filter;

    return eventDates === null || eventDates === void 0 ? void 0 : (_eventDates$filter = eventDates.filter(function (date) {
      return !!date;
    })) === null || _eventDates$filter === void 0 ? void 0 : _eventDates$filter.map(function (date) {
      return luxon/* DateTime.fromISO */.ou.fromISO(date.time[0]).toFormat('HH:mm');
    });
  };

  function timeOptionsOfSelectedDay(date, dates) {
    if (!date || !(dates !== null && dates !== void 0 && dates.length)) {
      return [];
    }

    return dates.map(function (eventDate) {
      return eventDate.time[0];
    }).map(function (item) {
      return item ? luxon/* DateTime.fromFormat */.ou.fromFormat(item, 'TT').toFormat('T') : null;
    });
  }

  function isTimeOptionsIncludesNull() {
    return timeOptionsOfSelectedDay(selectedDate, eventDates).includes(null);
  }

  function canShowTimeSelect() {
    var timeOptionsLength = timeOptionsOfSelectedDay(selectedDate, eventDates).length;
    return timeOptionsLength > 1 || timeOptionsLength === 1 && !isTimeOptionsIncludesNull();
  }

  function getReservationPostData() {
    var reservationPostData = {
      event: actionData.remote_id
    };
    var user = auth && auth.getUser();

    if (user) {
      Object.assign(reservationPostData, {
        email: user.email,
        phone_number: user.phone
      });
    }

    if (user && user.first_name) {
      Object.assign(reservationPostData, {
        first_name: user.first_name,
        last_name: user.last_name
      });
    }

    return reservationPostData;
  }

  function buySmartBilet() {
    var utmParams = Object.keys(router.query).filter(function (i) {
      return i.includes('utm_') || !i.includes('yclid');
    }).reduce(function (acc, cur) {
      acc.push("".concat(cur, "=").concat(router.query[cur]));
      return acc;
    }, []);
    var user = auth === null || auth === void 0 ? void 0 : auth.getUser();
    var userParams = user && ['first_name', 'phone_number', 'email'].map(function (i) {
      return {
        k: "user_".concat(i),
        v: encodeURIComponent( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        user[i] === Object(user[i]) ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        user[i][Object.keys(user[i])[0]] : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        user[i])
      };
    }).filter(function (i) {
      return !!i.v && i.v !== 'null';
    }).map(function (i) {
      return i.k === 'user_phone_number' ? booking_form_objectSpread(booking_form_objectSpread({}, i), {}, {
        v: i.v ? "+7".concat(i.v) : ''
      }) : i;
    }).reduce(function (acc, cur) {
      switch (cur.k) {
        case 'user_phone_number':
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          acc.push("user_phone=".concat(cur.v[cur.k] || cur.v));
          break;

        case 'user_first_name':
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          acc.push("user_name=".concat(cur.v[cur.k] || cur.v));
          break;

        default:
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          acc.push("".concat(cur.k, "=").concat(cur.v[cur.k] || cur.v));
      }

      return acc;
    }, []);
    setWidgetSrc(actionData.smartbilet_url + (!!utmParams && !!utmParams.length ? "&".concat(utmParams.join('&')) : '') + (!!userParams && !!userParams.length ? "&".concat(userParams.join('&')) : ''));
  }

  function showSmartBiletForm() {
    var smartBiletUrl = '';
    http/* http.post */.d.post(urls.V3.reservations, getReservationPostData(), null, {
      contentType: 'json',
      withTokenRequest: true
    }).then(function (response) {
      smartBiletUrl = "".concat(actionData.smartbilet_url, "&reservation_id=").concat(response.data.id);
      return http/* http.get */.d.get(urls.V2.smartbiletCheck, {
        smartbilet_url: smartBiletUrl
      });
    }).then(function (response) {
      var responseText = response.replace(/"/g, '');
      setSmartbiletLoadStatus(responseText);

      if (responseText === 'OK') {
        buySmartBilet();
      }
    })["catch"](function () {
      setSmartbiletLoadStatus("ERROR");
    });
  }

  (0,react.useEffect)(function () {
    var user = auth === null || auth === void 0 ? void 0 : auth.getUser();

    if (user) {
      reset({
        name: user.first_name,
        phone: user.phone_number || '',
        email: user.email,
        surname: user.last_name || '',
        action: actionData
      });
    }
  }, [auth, reset, actionData]);
  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var eventDatesData, timeOptions;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!selectedDate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return http/* http.get */.d.get(urls.V3.eventDates, {
                  limit: 9e9,
                  event: actionData.id,
                  start_date: luxon/* DateTime.fromFormat */.ou.fromFormat(selectedDate, 'dd.LL.yyyy').toFormat('yyyy-LL-dd')
                });

              case 3:
                eventDatesData = _context.sent;
                setEventDates(eventDatesData.results);

                if (eventDatesData.results.length) {
                  timeOptions = timeOptionsOfSelectedDay(selectedDate, eventDatesData.results);

                  if (timeOptions.length === 1) {
                    setTime(timeOptions[0]);
                  } else {
                    setTime('');
                  }
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetch.apply(this, arguments);
    }

    fetch();
    setCalendarOpen(false);
  }, [selectedDate]);
  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch2.apply(this, arguments);
    }

    function _fetch2() {
      _fetch2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var configData;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http/* http.get */.d.get(urls.V2.config).then(function (data) {
                  return {
                    isSber: data.find(function (elem) {
                      return elem.name === 'IS_SBER_ACTIVE';
                    }).value,
                    isTinkoff: data.find(function (elem) {
                      return elem.name === 'IS_TINKOFF_ACTIVE';
                    }).value
                  };
                });

              case 2:
                configData = _context2.sent;

                if (configData.isTinkoff && !configData.isSber) {
                  setBank('tinkoff');
                } else if (!configData.isTinkoff && configData.isSber) {
                  setBank('sber');
                } else if (configData.isTinkoff && configData.isSber) {
                  showBankSelect(true);
                } else {
                  setBank('tinkoff');
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _fetch2.apply(this, arguments);
    }

    fetch();
  }, []);
  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch3.apply(this, arguments);
    }

    function _fetch3() {
      _fetch3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var configData;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!isCertificateTypeWithOpenDate) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return http/* http.get */.d.get(urls.V2.config).then(function (data) {
                  return {
                    isSber: data.find(function (elem) {
                      return elem.name === 'IS_SBER_ACTIVE';
                    }).value,
                    isTinkoff: data.find(function (elem) {
                      return elem.name === 'IS_TINKOFF_ACTIVE';
                    }).value
                  };
                });

              case 3:
                configData = _context3.sent;

                if (configData.isTinkoff && !configData.isSber) {
                  setBank('tinkoff');
                } else if (!configData.isTinkoff && configData.isSber) {
                  setBank('sber');
                } else if (configData.isTinkoff && configData.isSber) {
                  showBankSelect(true);
                } else {
                  setBank('tinkoff');
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _fetch3.apply(this, arguments);
    }

    fetch();
  }, [isCertificateTypeWithOpenDate]);
  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch4.apply(this, arguments);
    }

    function _fetch4() {
      _fetch4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
        var _actionData$nearest_e;

        var _DateTime$fromFormat, month, year, dates, eventDatesData;

        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(actionData.type === models_action/* ACTION_TYPES.purchase */.aI.purchase)) {
                  _context4.next = 3;
                  break;
                }

                showSmartBiletForm();
                return _context4.abrupt("return");

              case 3:
                if (!((_actionData$nearest_e = actionData.nearest_event) !== null && _actionData$nearest_e !== void 0 && _actionData$nearest_e.start_date)) {
                  _context4.next = 13;
                  break;
                }

                _DateTime$fromFormat = luxon/* DateTime.fromFormat */.ou.fromFormat(actionData.nearest_event.start_date, 'yyyy-LL-dd'), month = _DateTime$fromFormat.month, year = _DateTime$fromFormat.year;
                _context4.next = 7;
                return http/* http.get */.d.get(urls.V3.eventDatesCalendar, {
                  event: actionData.id,
                  month: month,
                  year: year
                });

              case 7:
                dates = _context4.sent;
                _context4.next = 10;
                return http/* http.get */.d.get(urls.V3.eventDates, {
                  limit: 9e9,
                  event: actionData.id,
                  start_date: luxon/* DateTime.now */.ou.now().toFormat('yyyy-LL-dd')
                });

              case 10:
                eventDatesData = _context4.sent;
                setPermittedDates((0,toConsumableArray/* default */.Z)(dates.results));
                setEventDates(eventDatesData.results);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _fetch4.apply(this, arguments);
    }

    fetch();
  }, [actionData]);
  (0,react.useEffect)(function () {
    document.documentElement.style.overflow = 'hidden';
    return function () {
      document.documentElement.style.overflow = 'visible';
    };
  }, []);
  (0,react.useEffect)(function () {
    if (bank && bankSelect) onSubmit();
  }, [bank]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
        setModalState: setModalState,
        customClose: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* CloseSVG */.b, {
          onClick: function onClick() {
            setModalState(models_modal/* initialModalState */.L);
            var url = new URL(window.location.href);
            url.searchParams["delete"]('order');
            router.replace(url.href, undefined, {
              shallow: true
            });
          },
          css: booking_form_ref10
        }),
        children: actionData.type !== models_action/* ACTION_TYPES.purchase */.aI.purchase && !isPayment ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H2, {
          css: booking_form_ref11,
          children: actionData.reservation_type === models_action/* RESERVATION_TYPES.shortened */.x5.shortened ? 'Заявка' : actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate ? 'Покупка' : 'Бронирование'
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H2, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            fontSize: 26,
            fontWeight: 700,
            fontFamily: 'Montserrat',
            color: '#282828'
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            marginTop: 10,
            marginLeft: -10,
            marginRight: -10
          }),  true ? "" : 0,  true ? "" : 0),
          children: isPayment ? 'Выберите способ оплаты' : ''
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
      children: !isPayment ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [actionData.type === models_action/* ACTION_TYPES.purchase */.aI.purchase && !!smartbiletLoadStatus && smartbiletLoadStatus === 'OK' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
          title: "SmartBilet",
          src: widgetSrc,
          css: booking_form_ref12
        }), actionData.type === models_action/* ACTION_TYPES.purchase */.aI.purchase && !!smartbiletLoadStatus && smartbiletLoadStatus === 'ERROR' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: booking_form_ref13,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H3, {
            children: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435"
          })
        }), actionData.type !== models_action/* ACTION_TYPES.purchase */.aI.purchase && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form/* Form */.l, {
            css: booking_form_ref14,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* default */.ZP, {
              text: "\u0418\u043C\u044F",
              name: "name",
              error: !!errors.name,
              errorMessage: (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
              control: control,
              registerProps: register('name')
            }), isSurnameFieldRequired(actionData) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* default */.ZP, {
              text: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
              name: "surname",
              error: !!errors.surname,
              errorMessage: (_errors$surname = errors.surname) === null || _errors$surname === void 0 ? void 0 : _errors$surname.message,
              control: control,
              registerProps: register('surname')
            }), isPhoneFieldRequired(actionData) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(phone_input/* PhoneInput */.s, {
              control: control,
              name: "phone",
              error: !!errors.phone,
              errorMessage: (_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.message
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* default */.ZP, {
              text: "E-mail",
              name: "email",
              control: control,
              registerProps: register('email'),
              error: !!errors.email,
              errorMessage: (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
            }), isDateRequired({
              isCertificateTypeWithOpenDate: isCertificateTypeWithOpenDate,
              shortReservation: shortReservation
            }) && !!(permittedDates !== null && permittedDates !== void 0 && permittedDates.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: booking_form_ref15,
              onClick: function onClick() {
                return setCalendarOpen(function (prev) {
                  return !prev;
                });
              },
              children: [selectedDate ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: luxon/* DateTime.fromFormat */.ou.fromFormat(selectedDate, 'dd.LL.yyyy').setLocale('ru').toFormat('dd MMMM')
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: booking_form_ref16,
                children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                css: booking_form_ref17,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                  xlinkHref: "#calendar"
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(booking_form_objectSpread({
                  position: 'absolute',
                  background: '#fff',
                  top: 34,
                  right: 0,
                  width: '100%',
                  maxWidth: 387,
                  overflow: 'hidden',
                  transition: '.2s',
                  zIndex: 10,
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"
                }, calendarOpen ? {
                  maxHeight: 330
                } : {
                  maxHeight: 0
                }),  true ? "" : 0,  true ? "" : 0),
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar_calendar/* default */.Z, {
                  additionalCss: {
                    padding: '24px 0'
                  },
                  enableMultiSelection: false,
                  latestEventDate: actionData.latest_event,
                  nearestEventDate: actionData.nearest_event,
                  initPermittedDates: permittedDates,
                  onDatePicked: function onDatePicked(values) {
                    if (values) {
                      setSelectedDate(values[0]);
                    }
                  },
                  onMonthChanged: /*#__PURE__*/function () {
                    var _ref18 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(month, year) {
                      return regenerator_default().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              return _context5.abrupt("return", http/* http.get */.d.get(urls.V3.eventDatesCalendar, {
                                event: actionData.id,
                                month: month,
                                year: year
                              }).then(function (res) {
                                return res.results;
                              }));

                            case 1:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x, _x2) {
                      return _ref18.apply(this, arguments);
                    };
                  }(),
                  initDates: getDates()
                })
              })]
            }), canShowTimeSelect() && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimeSelect, {
              options: getDayTime(),
              value: time,
              setValue: setTime
            })]
          }), selectedDate && eventDateForCurrentDate({
            eventDates: eventDates,
            time: time
          }) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: booking_form_ref19,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
              css: booking_form_ref20,
              children: "\u041C\u0435\u0441\u0442\u043E"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
              css: booking_form_ref21,
              children: (_eventDateForCurrentD = eventDateForCurrentDate({
                eventDates: eventDates,
                time: time
              })) === null || _eventDateForCurrentD === void 0 ? void 0 : _eventDateForCurrentD.place.title
            })]
          }), categoriesForSelectedDate({
            selectedDate: selectedDate,
            eventDates: eventDates,
            time: time,
            action: actionData,
            isCertificateTypeWithOpenDate: isCertificateTypeWithOpenDate
          }).map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: booking_form_ref22,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(booking_form_objectSpread({
                  position: "relative",
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  lineHeight: "1",
                  minHeight: "34px",
                  fontWeight: "400",
                  borderBottom: '1px solid #BFC1C3'
                }, getTicketsCountText(item) === QUOTA_REMAINDER_TYPES.noTickets ? {
                  opacity: 0.3
                } : {}),  true ? "" : 0,  true ? "" : 0),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                  css: booking_form_ref23,
                  children: item.title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                  css: booking_form_ref24,
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [(0,utils/* splitPriceByThree */.ax)(item.price), " \u20BD"]
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: booking_form_ref25,
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                      type: "button",
                      onClick: function onClick() {
                        return decreaseItem(item);
                      },
                      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                        backgroundImage: "url(".concat(minus.src, ")")
                      },  true ? "" : 0,  true ? "" : 0),
                      children: ' '
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                      children: !!orderTickets && orderTickets[item.id] || 0
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                      type: "button",
                      onClick: function onClick() {
                        return increaseItem(item);
                      },
                      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                        backgroundImage: "url(".concat(plus.src, ")")
                      },  true ? "" : 0,  true ? "" : 0),
                      children: ' '
                    })]
                  })]
                })]
              }), !!getTicketsCountText(item) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: booking_form_ref26,
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(fire_logo, {
                  css: _ref27
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  css: _ref28,
                  dangerouslySetInnerHTML: {
                    __html: getTicketsCountText(item)
                  }
                })]
              })]
            }, "buy-buttons-".concat(item.id));
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _ref29,
            children: [actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
              css: _ref30,
              children: ["\u0418\u0442\u043E\u0433\u043E ", totalPrice(), " \u20BD"]
            }), actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
              css: _ref31,
              children: ["\u0421\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0441\u0431\u043E\u0440 ", totalServicePrice(), " \u20BD"]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: _ref32,
              children: [actionData.service_fee === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                  css: _ref33,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                    xlinkHref: "#zero-percent"
                  })
                }), "\u0431\u0435\u0437 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u043E\u0433\u043E \u0441\u0431\u043E\u0440\u0430"]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                  css: _ref34,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                    xlinkHref: "#lock"
                  })
                }), "\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B"]
              }), actionData.payment_on_spot && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                  css: _ref35,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                    xlinkHref: "#free_cancel"
                  })
                }), "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u043E\u0442\u043C\u0435\u043D\u0430 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"]
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: _ref36,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_form/* CustomCheckBox */.b, {
                form: true,
                value: "buy-ticket-check",
                callback: function callback(e) {
                  setCheck(e.target.checked);
                },
                label: "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443",
                checked: check
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
              css: _ref37,
              children: ["\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443", ' ', actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate ? '"Купить"' : actionData.reservation_type === models_action/* RESERVATION_TYPES.shortened */.x5.shortened ? '"Оставить заявку"' : '"Забронировать"', ", \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: "/pages/publichnaya-oferta/",
                target: "_blank",
                children: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C \u043E\u0444\u0435\u0440\u0442\u044B"
              }), ' ', "\u0438", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: "/pages/polzovatelskoe-soglashenie/",
                target: "_blank",
                children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u043C \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435\u043C"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: _ref38,
              children: actionData.type === models_action/* ACTION_TYPES.certificate */.aI.certificate ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* RedButton */.QT, {
                disabled: !isValid || (isCertificateTypeWithOpenDate ? !Object.values(orderTickets).find(function (i) {
                  return i > 0;
                }) : !selectedDate || !Object.values(orderTickets).find(function (i) {
                  return i > 0;
                })),
                callback: function callback() {
                  /* eslint no-underscore-dangle: ["error", { "allow": ["_tmr"] }] */
                  _tmr.push({
                    type: 'reachGoal',
                    id: 3408105,
                    goal: 'book_click'
                  });

                  if (bankSelect) {
                    choosePayment();
                  } else {
                    onSubmit();
                  }
                },
                children: bankSelect ? 'Выбрать способ оплаты' : 'Купить'
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* RedButton */.QT, {
                disabled: !isValid || (shortReservation ? false : !selectedDate || !Object.values(orderTickets).find(function (i) {
                  return i > 0;
                })),
                callback: function callback() {
                  /* eslint no-underscore-dangle: ["error", { "allow": ["_tmr"] }] */
                  _tmr.push({
                    type: 'reachGoal',
                    id: 3408105,
                    goal: 'book_click'
                  });

                  onSubmit();
                },
                children: [actionData.type === models_action/* ACTION_TYPES.FREE */.aI.FREE && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                  children: "\u041F\u043E\u0441\u0435\u0442\u0438\u0442\u044C"
                }), actionData.type === models_action/* ACTION_TYPES.reservation */.aI.reservation && // eslint-disable-next-line react/jsx-no-useless-fragment
                (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                  children: actionData.reservation_type === models_action/* RESERVATION_TYPES.shortened */.x5.shortened ? 'Оставить заявку' : 'Забронировать'
                })]
              })
            })]
          })]
        })]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [bank && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: _ref39
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            maxWidth: 760,
            minWidth: '100%',
            '.payment-button': (0,defineProperty/* default */.Z)({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: 16,
              border: '1px solid rgba(0, 0, 0, 0.2)',
              borderRadius: 12
            }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
              alignItems: 'flex-start',
              padding: 12,
              gap: 20
            }),
            '.payment-button-title': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              textAlign: 'left'
            },
            '.payment-button-title-heading': (0,defineProperty/* default */.Z)({
              fontSize: 18,
              fontWeight: 700,
              lineHeight: 1.1,
              fontFamily: 'Montserrat'
            }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
              fontSize: 16,
              lineHeight: 1.3
            }),
            '.payment-button-title-description': (0,defineProperty/* default */.Z)({
              fontSize: 16,
              fontWeight: 500,
              lineHeight: 1.2,
              color: 'rgba(0, 0, 0, 0.6)',
              fontFamily: 'Montserrat'
            }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
              fontSize: 14
            })
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            marginTop: 30,
            marginLeft: -10,
            marginRight: -10
          }),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
            type: "button",
            className: "payment-button",
            onClick: function onClick() {
              return setBank('sber');
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
              className: "payment-button-title",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "payment-button-title-heading",
                children: "\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043A\u0430\u0440\u0442\u0430"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "payment-button-title-description",
                children: "\u041E\u043F\u043B\u0430\u0442\u0430 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u043E\u0439"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(payment_marks, {
              css: _ref40
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
            type: "button",
            className: "payment-button",
            onClick: function onClick() {
              return setBank('tinkoff');
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
              className: "payment-button-title",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "payment-button-title-heading",
                children: "\u0422\u0438\u043D\u044C\u043A\u043E\u0444\u0444 \u041A\u0430\u0441\u0441\u0430"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "payment-button-title-description",
                children: "\u0414\u043B\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u044B \u0422\u0438\u043D\u044C\u043A\u043E\u0444\u0444"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tinkoff, {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
                width: '100%',
                maxWidth: 129,
                height: 32
              }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
                maxWidth: 103,
                height: 24
              }),  true ? "" : 0,  true ? "" : 0)
            })]
          })]
        })]
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/animations/loading.tsx



function loading_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var loading_ref2 =  true ? {
  name: "18ji2p4",
  styles: "width:300px"
} : 0;

var loading_ref3 =  true ? {
  name: "1p1a733",
  styles: "position:relative;width:100%;height:2px;background:#f7f7f7;overflow:hidden;border-radius:10px;margin-top:20px;&:before{content:\"\";background:#ff3b00;width:80px;height:100%;z-index:1;position:absolute;transform:translate(0, 0);animation:moving 2s infinite;border-radius:10px;}"
} : 0;

function Loading(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: loading_ref2,
    children: [children, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: loading_ref3
    })]
  });
}
;// CONCATENATED MODULE: ./components/booking-form/payment-modal.tsx




function payment_modal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var payment_modal_ref4 =  true ? {
  name: "mu0u4b",
  styles: "padding:23px 30px 20px 30px"
} : 0;

var payment_modal_ref5 =  true ? {
  name: "6is528",
  styles: "font-size:18px;color:#333"
} : 0;

var payment_modal_ref6 =  true ? {
  name: "1btayzr",
  styles: "padding:14px 30px 30px 30px"
} : 0;

var payment_modal_ref7 =  true ? {
  name: "1xhh2w5",
  styles: "height:230px;display:flex;justify-content:center;align-items:center"
} : 0;

var payment_modal_ref8 =  true ? {
  name: "1ut5urr",
  styles: "margin-top:28px;display:flex;justify-content:center"
} : 0;

function PaymentModal(_ref) {
  var _orderData$certificat, _orderData$certificat2, _auth$getUser, _orderData$certificat3;

  var queryStatus = _ref.status,
      setModalState = _ref.setModalState,
      gbReccomendLink = _ref.gbReccomendLink;
  var auth = (0,authorization/* useAuthorization */.o)();

  var _useState = (0,react.useState)('loading'),
      fetchStatus = _useState[0],
      setFetchStatus = _useState[1];

  var _useState2 = (0,react.useState)(null),
      orderData = _useState2[0],
      setOrderData = _useState2[1];

  var router = (0,next_router.useRouter)();
  var MAX_ATTEMPT_FETCH_CERTIFICATES = 15;

  function fetchReservation(_x) {
    return _fetchReservation.apply(this, arguments);
  }

  function _fetchReservation() {
    _fetchReservation = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(reservationId) {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return http/* http.get */.d.get(urls.V3.reservationsItem(reservationId), null, null, {
                contentType: 'json',
                withTokenRequest: true
              });

            case 3:
              response = _context2.sent;
              _context2.next = 6;
              return new Promise(function (resolve) {
                return (// eslint-disable-next-line no-promise-executor-return
                  setTimeout(function () {
                    return resolve(response);
                  }, 1000)
                );
              });

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              _context2.next = 13;
              return new Promise(function (resolve) {
                return (// eslint-disable-next-line no-promise-executor-return
                  setTimeout(function () {
                    return resolve(null);
                  }, 1000)
                );
              });

            case 13:
              return _context2.abrupt("return", _context2.sent);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return _fetchReservation.apply(this, arguments);
  }

  function onClearReservationLocalStorage() {
    (0,browserStorage/* setLocalStorageItem */.D)('reservation', '');
  }

  function isCertificatesEqualToTicketsCount(_ref2) {
    var count = _ref2.count,
        certificates = _ref2.certificates;
    var sum = count.reduce(function (a, b) {
      return a + b;
    });
    var numberOfFinishedCerts = certificates.map(function (_ref3) {
      var file = _ref3.file;
      return file;
    }).filter(Boolean).length;
    return sum === numberOfFinishedCerts;
  }

  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var reservationId, fetchCount, orderResponse;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reservationId = (0,browserStorage/* getLocalStorageItem */.l)(models_action/* ACTION_TYPES.reservation */.aI.reservation);

                if (!(reservationId && queryStatus === 'success')) {
                  _context.next = 16;
                  break;
                }

                fetchCount = 0;
                orderResponse = null;

              case 4:
                if (!(fetchCount < MAX_ATTEMPT_FETCH_CERTIFICATES)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 7;
                return fetchReservation(reservationId);

              case 7:
                orderResponse = _context.sent;
                setOrderData(orderResponse);

                if (!(orderResponse && isCertificatesEqualToTicketsCount(orderResponse))) {
                  _context.next = 12;
                  break;
                }

                setFetchStatus('success');
                return _context.abrupt("break", 15);

              case 12:
                fetchCount += 1;
                _context.next = 4;
                break;

              case 15:
                if (!orderResponse || !isCertificatesEqualToTicketsCount(orderResponse)) {
                  setFetchStatus('error');
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetch.apply(this, arguments);
    }

    fetch();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: payment_modal_ref4,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
        css: payment_modal_ref5,
        children: [fetchStatus === 'success' && 'Успех', fetchStatus === 'error' && 'Ошибка']
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: payment_modal_ref6,
      children: [fetchStatus === 'loading' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: payment_modal_ref7,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/img/throbber.png"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
        children: [fetchStatus === 'success' && orderData && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(orderData === null || orderData === void 0 ? void 0 : (_orderData$certificat = orderData.certificates) === null || _orderData$certificat === void 0 ? void 0 : _orderData$certificat.length) === 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u0430, \u0432\u0430\u0448 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u043F\u043E\u0447\u0442\u0443, \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043A\u0430\u0447\u0430\u0442\u044C \u0435\u0433\u043E \u043D\u0438\u0436\u0435"
          }), (orderData === null || orderData === void 0 ? void 0 : (_orderData$certificat2 = orderData.certificates) === null || _orderData$certificat2 === void 0 ? void 0 : _orderData$certificat2.length) > 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u0430, \u0432\u0430\u0448\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0447\u0442\u0443, \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043A\u0430\u0447\u0430\u0442\u044C \u0438\u0445 \u043D\u0438\u0436\u0435"
          })]
        }), queryStatus === 'error' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u043F\u043E\u043A\u0443\u043F\u043A\u0430 \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437"
        }), fetchStatus === 'error' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: ["\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438\u0445 \u043D\u0430 \u043F\u043E\u0447\u0442\u0435", ' ', (orderData === null || orderData === void 0 ? void 0 : orderData.email) || (auth === null || auth === void 0 ? void 0 : (_auth$getUser = auth.getUser()) === null || _auth$getUser === void 0 ? void 0 : _auth$getUser.email) || '(указанной при бронировании)', ' ', "\u0438\u043B\u0438 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0435\u0439 \u0441\u0430\u0439\u0442\u0430"]
        })]
      }), fetchStatus === 'success' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'flex',
          flexDirection: 'column'
        }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          gap: 10
        }),  true ? "" : 0,  true ? "" : 0),
        children: fetchStatus === 'success' && !!(orderData !== null && orderData !== void 0 && (_orderData$certificat3 = orderData.certificates) !== null && _orderData$certificat3 !== void 0 && _orderData$certificat3.length) && orderData.certificates.map(function (certificate) {
          var _certificate$file, _certificate$file$spl;

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            target: "_blank",
            download: true,
            href: certificate.file,
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              width: 'fit-content',
              color: '#f44336',
              '&:hover': {
                color: 'rgba(244, 67, 54, 0.85)'
              }
            }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              fontSize: 18
            }),  true ? "" : 0,  true ? "" : 0),
            rel: "noreferrer",
            children: (_certificate$file = certificate.file) === null || _certificate$file === void 0 ? void 0 : (_certificate$file$spl = _certificate$file.split('/')) === null || _certificate$file$spl === void 0 ? void 0 : _certificate$file$spl.pop()
          }, certificate.file);
        })
      }), fetchStatus !== 'loading' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: payment_modal_ref8,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* RedButton */.QT, {
          callback: function callback() {
            setModalState(models_modal/* initialModalState */.L);
            onClearReservationLocalStorage();

            if (gbReccomendLink && queryStatus === 'success') {
              router.push(gbReccomendLink);
            }
          },
          children: [queryStatus === 'success' && 'Отлично', queryStatus === 'error' && 'Закрыть']
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./components/form/SubscribeForm/index.tsx
var SubscribeForm = __webpack_require__(145);
;// CONCATENATED MODULE: ./components/subscribe/subscribe-modal.tsx


function subscribe_modal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var subscribe_modal_ref2 =  true ? {
  name: "wutrmn",
  styles: "display:flex;flex-direction:column;gap:7px"
} : 0;

var subscribe_modal_ref3 =  true ? {
  name: "1x0r25c",
  styles: "color:green;font-size:18px;line-height:25px;margin-top:0.83em;margin-bottom:0.83em;flex-direction:row;display:flex;align-items:baseline;gap:7px"
} : 0;

var subscribe_modal_ref4 =  true ? {
  name: "ib1pfa",
  styles: "width:16px;height:14px"
} : 0;

function SubscribeModal(_ref) {
  var email = _ref.email,
      notSeason = _ref.notSeason;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  var modalState = (0,modal/* useModal */.dd)();

  if (!modalState) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
      setModalState: modalState === null || modalState === void 0 ? void 0 : modalState.setModalState,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H2, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            fontSize: 21,
            color: theme.colors.black,
            lineHeight: '29.4px'
          },  true ? "" : 0,  true ? "" : 0),
          children: "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u043D\u0430 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435"
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: subscribe_modal_ref2,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography.H2, {
          css: subscribe_modal_ref3,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(check_mark, {
            css: subscribe_modal_ref4
          }), " \u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0430"]
        }), notSeason ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: ["\u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0435 \u0441\u0435\u0437\u043E\u043D, \u043D\u043E \u043C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043C, \u043A\u043E\u0433\u0434\u0430 \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0431\u0438\u043B\u0435\u0442\u043E\u0432! \u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0412\u0430\u043C \u043F\u0438\u0441\u044C\u043C\u043E \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
            children: email
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: ["\u0422\u0435\u043F\u0435\u0440\u044C \u0432\u044B \u0443\u0437\u043D\u0430\u0435\u0442\u0435 \u043E \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0431\u0438\u043B\u0435\u0442\u043E\u0432 \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043F\u0435\u0440\u0432\u044B\u043C! \u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u043F\u0438\u0441\u044C\u043C\u043E \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
            children: email
          })]
        })]
      })
    })]
  });
}

/* harmony default export */ var subscribe_modal = (SubscribeModal);
;// CONCATENATED MODULE: ./components/form/SubscribeForm/modal.tsx


function modal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var modal_ref2 =  true ? {
  name: "wutrmn",
  styles: "display:flex;flex-direction:column;gap:7px"
} : 0;

function SubscribeModalForm(_ref) {
  var eventId = _ref.eventId,
      notSeason = _ref.notSeason,
      currentCity = _ref.currentCity,
      onSuccessSubscribe = _ref.onSuccessSubscribe;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  var modalState = (0,modal/* useModal */.dd)();

  if (!modalState) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
      setModalState: modalState === null || modalState === void 0 ? void 0 : modalState.setModalState,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H2, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            fontSize: 21,
            color: theme.colors.black,
            lineHeight: '29.4px'
          },  true ? "" : 0,  true ? "" : 0),
          children: "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u043D\u0430 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435"
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: modal_ref2,
        children: [notSeason ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
          children: "\u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0435 \u0441\u0435\u0437\u043E\u043D, \u043D\u043E \u043C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043C, \u043A\u043E\u0433\u0434\u0430 \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0431\u0438\u043B\u0435\u0442\u043E\u0432! \u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0441\u0432\u043E\u0439 e-mail, \u0447\u0442\u043E\u0431\u044B \u0431\u044B\u0442\u044C \u0432 \u043A\u0443\u0440\u0441\u0435 \u043F\u0435\u0440\u0432\u044B\u043C\u0438!"
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
          children: "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 e-mail, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043B\u0438, \u043A\u043E\u0433\u0434\u0430 \u0431\u0438\u043B\u0435\u0442\u044B \u0441\u043D\u043E\u0432\u0430 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribeForm/* default */.Z, {
          source: notSeason ? 'SeasonStart' : 'ArchiveSubscription',
          defaultStyle: true,
          eventId: eventId,
          currentCity: currentCity,
          onSuccessSubscribe: onSuccessSubscribe
        })]
      })
    })]
  });
}

/* harmony default export */ var SubscribeForm_modal = (SubscribeModalForm);
// EXTERNAL MODULE: ./components/actions/images-slider.tsx
var images_slider = __webpack_require__(3024);
// EXTERNAL MODULE: ./lib/api/apiUrl.ts
var apiUrl = __webpack_require__(7050);
// EXTERNAL MODULE: ./components/posts/posts.tsx
var posts = __webpack_require__(4553);
;// CONCATENATED MODULE: ./components/actions/SimilarEventsBlock.tsx






function SimilarEventsBlockMemo(_ref) {
  var _eventsList$results;

  var eventData = _ref.eventData,
      currentCity = _ref.currentCity;

  var _useState = (0,react.useState)(null),
      eventsList = _useState[0],
      setEventsList = _useState[1];

  (0,react.useEffect)(function () {
    http/* http.get */.d.get("".concat(urls.V4.baseUrl, "events/").concat(eventData === null || eventData === void 0 ? void 0 : eventData.id, "/similar/"), {
      limit: 8,
      offset: 0
    }).then(function (res) {
      return setEventsList(res);
    })["catch"](function () {
      return setEventsList(null);
    });
  }, [eventData]);

  if (!eventData) {
    return null;
  }

  return eventsList && (_eventsList$results = eventsList.results) !== null && _eventsList$results !== void 0 && _eventsList$results.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(posts/* Posts */.V, {
    title: "\u041F\u043E\u0445\u043E\u0436\u0438\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
    actions: eventsList,
    currentCity: currentCity,
    href: ['', currentCity.url, 'catalog', ''].join('/')
  }) : null;
}

var SimilarEventsBlock = /*#__PURE__*/(0,react.memo)(SimilarEventsBlockMemo, function (oldProps, newProps) {
  return oldProps.eventData.id === newProps.eventData.id;
});
// EXTERNAL MODULE: ./components/person/people-slider.tsx
var people_slider = __webpack_require__(8592);
;// CONCATENATED MODULE: ./components/person/people-modal.tsx


function people_modal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var people_modal_ref4 =  true ? {
  name: "15k15ha",
  styles: "display:flex;padding:0 8px 10px 8px;gap:8px"
} : 0;

var people_modal_ref5 =  true ? {
  name: "1f6lq61",
  styles: "width:33%"
} : 0;

var people_modal_ref6 =  true ? {
  name: "14wyfrx",
  styles: "width:67%"
} : 0;

var people_modal_ref7 =  true ? {
  name: "1qr3jc0",
  styles: "padding-right:5px"
} : 0;

var people_modal_ref8 =  true ? {
  name: "hykqa0",
  styles: "color:#f44336"
} : 0;

var people_modal_ref9 =  true ? {
  name: "4ky2pj",
  styles: "color:#000000"
} : 0;

function PeopleModal(_ref) {
  var personList = _ref.personList,
      setModalState = _ref.setModalState;
  var personsBySpecialization = Object.entries(personList.reduce(function (acc, person) {
    person.specialization_titles.forEach(function (title) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!acc[title]) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[title] = [];
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      acc[title].push({
        fullName: [person.first_name, person.last_name].join(' '),
        slug: person.slug
      });
    });
    return acc;
  }, {}));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
      setModalState: setModalState,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitle */.r6, {
        children: "\u0422\u0432\u043E\u0440\u0447\u0435\u0441\u043A\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
      children: personsBySpecialization.map(function (_ref2) {
        var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
            specialization = _ref3[0],
            artistList = _ref3[1];

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: people_modal_ref4,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography.H4, {
            css: people_modal_ref5,
            children: [specialization, ":"]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: people_modal_ref6,
            children: artistList.map(function (person, i) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                css: people_modal_ref7,
                onClick: function onClick() {
                  return setModalState({
                    show: false,
                    content: ''
                  });
                },
                type: "button",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU, {
                  href: ['', 'person', person.slug, ''].join('/'),
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    css: people_modal_ref8,
                    children: [person.fullName, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                      css: people_modal_ref9,
                      children: artistList.length === i + 1 ? '' : ','
                    })]
                  })
                })
              }, "".concat(specialization, "-").concat(person.slug));
            })
          })]
        }, specialization);
      })
    })]
  });
}
// EXTERNAL MODULE: ./public/img/triangle-down.svg
var triangle_down = __webpack_require__(4648);
// EXTERNAL MODULE: ./public/img/user-no-photo.png
var user_no_photo = __webpack_require__(7058);
;// CONCATENATED MODULE: ./components/actions/PersonalsBlock.tsx



function PersonalsBlock_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PersonalsBlock_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PersonalsBlock_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PersonalsBlock_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PersonalsBlock_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var PersonalsBlock_ref2 =  true ? {
  name: "g46w8s",
  styles: "margin-bottom:30px"
} : 0;

var PersonalsBlock_ref3 =  true ? {
  name: "48ia3r",
  styles: "display:flex;flex-wrap:wrap;gap:30px"
} : 0;

var PersonalsBlock_ref4 =  true ? {
  name: "1dcd86e",
  styles: "position:relative;width:142px;height:142px;border-radius:150px;overflow:hidden;object-fit:cover"
} : 0;

var PersonalsBlock_ref5 =  true ? {
  name: "12adf3y",
  styles: "position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover"
} : 0;

var PersonalsBlock_ref6 =  true ? {
  name: "c03kn0",
  styles: "display:flex;justify-content:flex-end;margin-top:20px"
} : 0;

var PersonalsBlock_ref7 =  true ? {
  name: "gq7qss",
  styles: "display:flex;align-items:center;gap:10px;color:#f44336"
} : 0;

var PersonalsBlock_ref8 =  true ? {
  name: "17c5m7z",
  styles: "width:12px;height:12px;fill:#000"
} : 0;

function PersonsBlockMemo(_ref) {
  var _persons$results;

  var eventData = _ref.eventData;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  var modalState = (0,modal/* useModal */.dd)();

  var _useState = (0,react.useState)(null),
      persons = _useState[0],
      setPersons = _useState[1];

  (0,react.useEffect)(function () {
    http/* http.get */.d.get(urls.V3.persons, {
      limit: 50,
      offset: 0,
      event__in: eventData.id
    }).then(function (res) {
      return setPersons(res);
    })["catch"](function () {
      return setPersons(null);
    });
  }, [eventData]);

  if (!eventData) {
    return null;
  }

  return persons && (_persons$results = persons.results) !== null && _persons$results !== void 0 && _persons$results.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: PersonalsBlock_ref2,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        fontFamily: 'Montserrat',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '0.04em',
        color: theme.colors.red,
        textTransform: 'uppercase',
        marginBottom: 10
      },  true ? "" : 0,  true ? "" : 0),
      children: "\u041F\u0435\u0440\u0441\u043E\u043D\u044B"
    }), persons.results.length > 3 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(people_slider/* PeopleSlider */.C, {
      personList: persons.results
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: PersonalsBlock_ref3,
      children: persons.results.map(function (person) {
        var _person$first_image;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* Link */.rU, {
          href: ['', 'person', person.slug, ''].join('/'),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: PersonalsBlock_ref4,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(picture/* Image */.Ee, {
              css: PersonalsBlock_ref5,
              alt: "".concat(person.first_name, " ").concat(person.last_name),
              is360: true,
              image: (_person$first_image = person.first_image) !== null && _person$first_image !== void 0 && _person$first_image.image ? person.first_image : user_no_photo/* default.src */.Z.src
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              color: theme.colors.red,
              textAlign: 'center'
            },  true ? "" : 0,  true ? "" : 0),
            children: [person.first_name, " ", person.last_name]
          })]
        }, "PersonLink__".concat(person.id));
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: PersonalsBlock_ref6,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
        css: PersonalsBlock_ref7,
        type: "button",
        onClick: function onClick() {
          if (modalState) {
            modalState.setModalState(function (oldState) {
              return PersonalsBlock_objectSpread(PersonalsBlock_objectSpread({}, oldState), {}, {
                show: true,
                content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PeopleModal, {
                  personList: persons.results,
                  setModalState: modalState.setModalState
                })
              });
            });
          }
        },
        children: ["\u0412\u0441\u044F \u0442\u0432\u043E\u0440\u0447\u0435\u0441\u043A\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(triangle_down/* default */.Z, {
          css: PersonalsBlock_ref8
        })]
      })
    })]
  }) : null;
}

var PersonsBlock = /*#__PURE__*/(0,react.memo)(PersonsBlockMemo, function (oldProps, newProps) {
  return oldProps.eventData.id === newProps.eventData.id;
});
// EXTERNAL MODULE: ./providers/history/index.tsx
var providers_history = __webpack_require__(3702);
;// CONCATENATED MODULE: ./pages/[city]/actions/[slug].tsx





function _slug_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function _slug_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _slug_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _slug_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _slug_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }































































var _slug_ref2 =  true ? {
  name: "1aynuae",
  styles: "width:20px;height:20px"
} : 0;

var _slug_ref3 =  true ? {
  name: "ib1pfa",
  styles: "width:16px;height:14px"
} : 0;

var _slug_ref4 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _slug_ref5 =  true ? {
  name: "1hrgoqa",
  styles: "margin-bottom:16px;font-size:14px;color:#282828;font-family:'Montserrat', serif"
} : 0;

var _slug_ref6 =  true ? {
  name: "1m7vnvg",
  styles: "display:flex;align-items:baseline;gap:8px;margin-top:10px;margin-bottom:18px;color:#282828"
} : 0;

var _slug_ref7 =  true ? {
  name: "1eg0rk6",
  styles: "width:18px;height:18px"
} : 0;

var _slug_ref8 =  true ? {
  name: "1ckdq4h",
  styles: "font-size:14px;font-family:Montserrat, serif"
} : 0;

var _slug_ref9 =  true ? {
  name: "d3kzo8",
  styles: "font-weight:bolder"
} : 0;

var _slug_ref10 =  true ? {
  name: "hwhjw9",
  styles: "display:flex;justify-content:flex-start;flex-wrap:wrap;gap:6px;margin-bottom:24px"
} : 0;

var _slug_ref11 =  true ? {
  name: "1ev38xb",
  styles: "width:100%;display:flex;justify-content:center;align-items:center;border:1.5px solid #F44336;padding:16px;gap:16px"
} : 0;

var _slug_ref12 =  true ? {
  name: "pu36p5",
  styles: "width:44px;height:44px"
} : 0;

var _slug_ref13 =  true ? {
  name: "iqoq9n",
  styles: "margin-top:20px"
} : 0;

var _slug_ref14 =  true ? {
  name: "186a9ob",
  styles: "width:24px;min-width:24px"
} : 0;

var _slug_ref15 =  true ? {
  name: "1n62ygo",
  styles: "margin:25px 0;display:flex;flex-direction:column;gap:16px;font-family:Golos;font-weight:400;font-size:14px;line-height:16px;color:#7D7B7A;text-align:left"
} : 0;

var _slug_ref16 =  true ? {
  name: "zatqba",
  styles: "display:flex;gap:10px;align-items:center"
} : 0;

var _slug_ref17 =  true ? {
  name: "1llo5fb",
  styles: "width:24px"
} : 0;

var _slug_ref18 =  true ? {
  name: "zatqba",
  styles: "display:flex;gap:10px;align-items:center"
} : 0;

var _slug_ref19 =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

var _slug_ref20 =  true ? {
  name: "1llo5fb",
  styles: "width:24px"
} : 0;

var _slug_ref21 =  true ? {
  name: "zatqba",
  styles: "display:flex;gap:10px;align-items:center"
} : 0;

var _slug_ref22 =  true ? {
  name: "186a9ob",
  styles: "width:24px;min-width:24px"
} : 0;

var _slug_ref23 =  true ? {
  name: "zatqba",
  styles: "display:flex;gap:10px;align-items:center"
} : 0;

var _slug_ref24 =  true ? {
  name: "186a9ob",
  styles: "width:24px;min-width:24px"
} : 0;

var _slug_ref25 =  true ? {
  name: "186a9ob",
  styles: "width:24px;min-width:24px"
} : 0;

var _slug_ref26 =  true ? {
  name: "zatqba",
  styles: "display:flex;gap:10px;align-items:center"
} : 0;

var _slug_ref27 =  true ? {
  name: "186a9ob",
  styles: "width:24px;min-width:24px"
} : 0;

var _slug_ref28 =  true ? {
  name: "avpsk8",
  styles: "margin-bottom:15px"
} : 0;

var _slug_ref29 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

var _slug_ref30 =  true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0;

var _slug_ref31 =  true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0;

var _slug_ref32 =  true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0;

var _slug_ref33 =  true ? {
  name: "15bxtr0",
  styles: "margin-bottom:36px"
} : 0;

var _slug_ref34 =  true ? {
  name: "ib1pfa",
  styles: "width:16px;height:14px"
} : 0;

function PageComponent(_ref) {
  var _eventData$block_1_de, _eventData$block_2_de, _css10, _css11, _eventData$images;

  var currentCity = _ref.currentCity,
      eventData = _ref.eventData,
      promos = _ref.promos,
      socials = _ref.socials,
      gbReccomendLink = _ref.gbReccomendLink,
      configOfSite = _ref.configOfSite;
  var auth = (0,authorization/* useAuthorization */.o)();
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();

  var _useState = (0,react.useState)({
    results: []
  }),
      viewed = _useState[0],
      setViewed = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isShowBuyButton = _useState2[0],
      setIsShowBuyButton = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      tsNextWidgetConfig = _useState3[0],
      setTsNextWidgetConfig = _useState3[1];

  var modalState = (0,modal/* useModal */.dd)();

  var _useState4 = (0,react.useState)({
    slide: null,
    visible: false
  }),
      imageModal = _useState4[0],
      setImageModal = _useState4[1];

  var router = (0,next_router.useRouter)();
  var seoAnalyticsFromButton = (0,utils_event/* useSendMetricsFromButton */.Gc)();
  var history = (0,providers_history/* useHistory */.k)();
  var buyButtonRef = (0,react.useRef)(null);

  var isArchive = function isArchive() {
    if ((0,utils_event/* isEventPassed */.Bz)(eventData) && !eventData.date_unknown) {
      return true;
    }

    return eventData.status === events/* archiveStatus */.ME || eventData.status === events/* closeStatus */.xp || eventData.status === events/* inactiveStatus */.mv;
  };

  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var viewedList;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,utils_viewed/* fetchViewed */.F)(eventData.id);

              case 2:
                viewedList = _context.sent;
                setViewed(viewedList);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetch.apply(this, arguments);
    }

    fetch();
    var viewedActions = [];
    viewedActions = (JSON.parse((0,browserStorage/* getLocalStorageItem */.l)('viewed-events') || '[]') || []).filter(function (id) {
      return id !== eventData.id;
    }).slice(0, 8) || [];
    (0,browserStorage/* setLocalStorageItem */.D)('viewed-events', JSON.stringify([eventData.id].concat((0,toConsumableArray/* default */.Z)(viewedActions))));
  }, [eventData.id]);
  (0,react.useEffect)(function () {
    var onScroll = function onScroll() {
      var element = buyButtonRef.current;
      var isScrolled = !!element && element.getBoundingClientRect().top < 0;
      setIsShowBuyButton(isScrolled);
    }; // clean up code


    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, []);
  (0,react.useEffect)(function () {
    http/* http.post */.d.post(urls.V2.eventViews, {
      Action: eventData.remote_id
    });

    if (eventData.type === 'tsnext_widget') {
      var tsNextWidgetJsUrl = configOfSite.find(function (item) {
        return item.name === 'TSNEXT_JS_URL';
      });
      var appIdNextWidget = configOfSite.find(function (item) {
        return item.name === 'TSNEXT_APP_TOKEN';
      });
      setTsNextWidgetConfig({
        jsUrl: "".concat(tsNextWidgetJsUrl === null || tsNextWidgetJsUrl === void 0 ? void 0 : tsNextWidgetJsUrl.value),
        appId: "".concat(appIdNextWidget === null || appIdNextWidget === void 0 ? void 0 : appIdNextWidget.value),
        id: eventData.tsnext_id,
        type: eventData.tsnext_type
      });
    } else {
      setTsNextWidgetConfig(null);
    }
  }, [eventData.remote_id]);
  var isRanOutOfTickets = eventData.event_categories.filter(function (cat) {
    return cat.is_active;
  }).filter(function (cat) {
    return cat.is_unlimited || cat.quantity;
  }).length === 0;
  (0,react.useEffect)(function () {
    if (router.isReady && (0,utils_event/* hasOwnPolyfill */.Qi)(router.query, 'order') && eventData.not_season) {
      return function () {
        return modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(models_modal/* initialModalState */.L);
      };
    }

    if (router.isReady && (0,utils_event/* hasOwnPolyfill */.Qi)(router.query, 'order') && eventData.type !== models_action/* ACTION_TYPES.tsnext_widget */.aI.tsnext_widget) {
      if (eventData.type === models_action/* ACTION_TYPES.partner_widget */.aI.partner_widget) {
        return modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(function (old) {
          return _slug_objectSpread(_slug_objectSpread({}, old), {}, {
            show: true,
            content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* ModalContentWrapper */.uE, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalTitleWrapper */.zq, {
                showClose: true,
                setModalState: modalState === null || modalState === void 0 ? void 0 : modalState.setModalState,
                customClose: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* CloseSVG */.b, {
                  onClick: function onClick() {
                    modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(models_modal/* initialModalState */.L);
                    var url = new URL(window.location.href);
                    url.searchParams["delete"]('order');
                    router.replace(url.href, undefined, {
                      shallow: true
                    });
                  },
                  css: _slug_ref2
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* ModalContent */.hz, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionWidget/* ActionWidget */.U, {
                  action: eventData
                })
              })]
            }),
            options: {},
            outsideCloseCallback: function outsideCloseCallback() {
              var url = new URL(window.location.href);
              url.searchParams["delete"]('order');
              router.replace(url.href, undefined, {
                shallow: true
              });
            }
          });
        });
      }

      modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(function (old) {
        var _configOfSite$find;

        return _slug_objectSpread(_slug_objectSpread({}, old), {}, {
          show: true,
          content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookingForm, {
            setModalState: modalState.setModalState,
            actionData: eventData,
            gbReccomendLink: gbReccomendLink,
            currentCity: currentCity,
            banOnSomeEmails: !!((_configOfSite$find = configOfSite.find(function (item) {
              return item.name === 'WARN_ON_RESTRICTED_EMAIL_DOMAINS';
            })) !== null && _configOfSite$find !== void 0 && _configOfSite$find.value),
            banEmails: configOfSite.find(function (item) {
              return item.name === 'RESTRICTED_EMAIL_DOMAINS';
            })
          }),
          options: eventData.type === models_action/* ACTION_TYPES.purchase */.aI.purchase ? {
            width: '50%'
          } : {},
          outsideCloseCallback: function outsideCloseCallback() {
            var url = new URL(window.location.href);
            url.searchParams["delete"]('order');
            router.replace(url.href, undefined, {
              shallow: true
            });
          }
        });
      });
    }

    return function () {
      return modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(models_modal/* initialModalState */.L);
    };
  }, [router.query.order]);
  (0,react.useEffect)(function () {
    var paymentStatus = router.query.payment_status;

    if (paymentStatus) {
      var reservationId = (0,browserStorage/* getLocalStorageItem */.l)(models_action/* ACTION_TYPES.reservation */.aI.reservation);

      if (reservationId) {
        http/* http.get */.d.get(urls.V4.reservationsItem(reservationId), null, null, {
          contentType: 'json',
          withTokenRequest: true
        }).then(function (reservationResponse) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          if (window.dataLayer.find(function (item) {
            return item.ecommerce;
          })) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.dataLayer.push({
              ecommerce: null
            });
          } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore


          window.dataLayer.push({
            ecommerce: {
              currencyCode: 'RUB',
              purchase: {
                actionField: {
                  id: reservationResponse.id
                },
                products: reservationResponse.payment_items.map(function (item) {
                  return {
                    id: reservationResponse.event.id,
                    name: reservationResponse.event.title,
                    price: item.price,
                    category: reservationResponse.event.marketing_category,
                    variant: item.name,
                    quantity: item.quantity
                  };
                })
              }
            }
          });
        });
      }

      modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(function (old) {
        return _slug_objectSpread(_slug_objectSpread({}, old), {}, {
          show: true,
          content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentModal, {
            gbReccomendLink: gbReccomendLink,
            status: paymentStatus,
            setModalState: modalState.setModalState
          }),
          outsideCloseCallback: function outsideCloseCallback() {
            modalState.setModalState(models_modal/* initialModalState */.L);

            if (gbReccomendLink && paymentStatus === 'success') {
              router.push(gbReccomendLink);
            }
          }
        });
      });
    }
  }, [router.query.payment_status, router.query.orderId]);
  (0,react.useEffect)(function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.dataLayer) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.dataLayer.find(function (item) {
        return item.ecommerce;
      })) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.dataLayer.push({
          ecommerce: null
        });
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'RUB',
          detail: {
            products: [{
              id: eventData.id,
              name: eventData.title,
              price: eventData.filter_price,
              category: eventData.marketing_category
            }]
          }
        }
      });
    }
  }, [eventData]);

  function onSuccessSubscribe(email) {
    modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(function (old) {
      return _slug_objectSpread(_slug_objectSpread({}, old), {}, {
        show: true,
        content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(subscribe_modal, {
          notSeason: eventData.not_season,
          email: email
        })
      });
    });
  }

  function onClickBuyButton() {
    seoAnalyticsFromButton.onSend(eventData, isRanOutOfTickets);
    var url = new URL(window.location.href);

    if (isRanOutOfTickets || eventData.not_season) {
      var _auth$getUser;

      if (eventData.subscription_confirmed) {
        return;
      }

      var email = auth === null || auth === void 0 ? void 0 : (_auth$getUser = auth.getUser()) === null || _auth$getUser === void 0 ? void 0 : _auth$getUser.email;

      if (email) {
        var _auth$getUser2;

        http/* http.post */.d.post(urls.V2.subscriptions, {
          source: eventData.not_season ? 'SeasonStart' : 'ArchiveSubscription',
          event_id: eventData.id,
          city: currentCity.remote_id,
          email: auth === null || auth === void 0 ? void 0 : (_auth$getUser2 = auth.getUser()) === null || _auth$getUser2 === void 0 ? void 0 : _auth$getUser2.email
        }).then(function () {
          onSuccessSubscribe(email);
        });
      } else {
        modalState === null || modalState === void 0 ? void 0 : modalState.setModalState(function (old) {
          return _slug_objectSpread(_slug_objectSpread({}, old), {}, {
            show: true,
            content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribeForm_modal, {
              notSeason: eventData.not_season,
              eventId: eventData.id,
              currentCity: currentCity,
              onSuccessSubscribe: onSuccessSubscribe
            })
          });
        });
      }

      return;
    }

    switch (eventData.type) {
      case 'certificate':
      case 'reservation':
      case 'purchase':
      case 'FREE':
      case 'partner_widget':
        url.searchParams.append('order', '');
        router.replace(url.href, undefined, {
          shallow: true
        });
        break;

      default:
        break;
    }
  }

  var createBreadCrumbs = function createBreadCrumbs() {
    if (history && history.lastPage && history.lastPage.type === 'compilation') {
      return [{
        title: 'Подборки',
        url: 'compilations'
      }, {
        title: history.lastPage.title || '',
        href: history.lastPage.url
      }, {
        title: eventData.title
      }];
    }

    return [{
      title: 'Каталог',
      url: 'catalog'
    }, {
      title: eventData.title
    }];
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* Container */.W, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
      padding: '15px 12px'
    }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
      padding: '0 !important'
    }),  true ? "" : 0,  true ? "" : 0),
    children: [tsNextWidgetConfig && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
        src: tsNextWidgetConfig.jsUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
        id: "for-new-widget",
        children: "var ppid = \"".concat(tsNextWidgetConfig.appId, "\"")
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
        marginBottom: 16
      }, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
        display: 'none'
      }),  true ? "" : 0,  true ? "" : 0),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
        currentCity: currentCity,
        items: createBreadCrumbs()
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        fontFamily: 'Golos',
        color: theme.colors.black
      },  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventBanner, {
        disabled: isArchive(),
        item: eventData,
        onButtonClick: function onButtonClick() {
          return onClickBuyButton();
        },
        isRanOutOfTickets: isRanOutOfTickets,
        tsNextWidgetConfig: tsNextWidgetConfig
      }), !eventData.date_unknown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: buyButtonRef,
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'none'
        }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          display: 'block',
          width: "100%",
          paddingRight: 20,
          paddingLeft: 20,
          position: "absolute",
          zIndex: 2
        }),  true ? "" : 0,  true ? "" : 0),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* RedButton */.QT, _slug_objectSpread(_slug_objectSpread({
          callback: function callback() {
            return onClickBuyButton();
          },
          disabled: isArchive(),
          full: true,
          montserrat: true,
          subscription_confirmed: eventData.status === events/* activeStatus */.cT && eventData.subscription_confirmed
        }, tsNextWidgetConfig && {
          'data-type': tsNextWidgetConfig.type,
          'data-uid': tsNextWidgetConfig.id,
          className: 'tsnext-widget'
        }), {}, {
          children: [eventData.status === events/* activeStatus */.cT && eventData.subscription_confirmed && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(check_mark, {
            css: _slug_ref3
          }), (0,utils_event/* getBuyButtonText */.A)(eventData, isRanOutOfTickets)]
        }))
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        itemScope: true,
        itemType: "https://schema.org/Event",
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'flex',
          marginTop: 30,
          marginBottom: 50
        }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          flexDirection: 'column',
          padding: '0 8px',
          marginTop: 0
        }),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          css: _slug_ref4,
          itemProp: "name",
          children: eventData.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({}, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            marginTop: 50
          }),  true ? "" : 0,  true ? "" : 0),
          className: "col-12 col-md-5 col-lg-4 col-xl-3",
          children: [eventData.type !== 'FREE' && eventData.reservation_count_text && !eventData.countdown_tickets && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: _slug_ref5,
            children: eventData.reservation_count_text
          }), eventData.type !== 'FREE' && eventData.countdown_tickets ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
            css: _slug_ref6,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(fire_logo, {
              css: _slug_ref7
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
              css: _slug_ref8,
              children: [(0,word_declension/* default */.Z)(eventData.countdown_tickets, 'Остался', 'Осталось', 'Осталось'), ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
                css: _slug_ref9,
                children: eventData.countdown_tickets
              }), ' ', (0,word_declension/* default */.Z)(eventData.countdown_tickets, 'билет', 'билета', 'билетов')]
            })]
          }) : '', (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _slug_ref10,
            children: [eventData.not_season && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelEvent, {
              text: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D",
              description: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D"
            }), eventData.hit && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelEvent, {
              text: "\u0445\u0438\u0442",
              description: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u044E\u0442 \u044D\u0442\u043E \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
            }), eventData.premiere && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelEvent, {
              text: "\u043F\u0440\u0435\u043C\u044C\u0435\u0440\u0430",
              description: "\u041F\u0440\u0435\u043C\u044C\u0435\u0440\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u044B \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
            }), eventData.first_time && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelEvent, {
              text: "\u0432\u043F\u0435\u0440\u0432\u044B\u0435",
              description: "\u0421\u043E\u0431\u044B\u0442\u0438\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u043F\u0435\u0440\u0432\u044B\u0435"
            }), eventData.best_reviews && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelEvent, {
              text: "\u043B\u0443\u0447\u0448\u0438\u0435 \u043E\u0442\u0437\u044B\u0432\u044B",
              description: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432\u044B\u0441\u043E\u043A\u043E \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u044E\u0442 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
            }), eventData.prepayment && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelEvent, {
              text: "\u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0430",
              description: "\u041E\u043D\u043B\u0430\u0439\u043D \u0432\u044B \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0443"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AsideEventBlock, {
            item: eventData,
            currentCity: currentCity
          }), eventData.pushkin_card_payment && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _slug_ref11,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pushkin/* default */.Z, {
              css: _slug_ref12
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                width: 220,
                fontSize: 14,
                fontWeight: 400,
                color: theme.colors.text
              },  true ? "" : 0,  true ? "" : 0),
              children: "\u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u043C\u043E\u0436\u043D\u043E \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u041F\u0443\u0448\u043A\u0438\u043D\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u043E\u0439"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              marginTop: 20,
              textAlign: 'center'
            }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              display: 'none'
            }),  true ? "" : 0,  true ? "" : 0),
            children: !(0,utils_event/* isEventPassed */.Bz)(eventData) && eventData.dates_txt && !isRanOutOfTickets && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* GBButton */.xV, _slug_objectSpread({
              callback: function callback() {
                return onClickBuyButton();
              },
              text: (0,utils_event/* getBuyButtonText */.A)(eventData, isRanOutOfTickets),
              size: "sm",
              modification: "shadow",
              buttonStyle: _slug_objectSpread({
                width: '100%',
                height: '40px',
                borderRadius: '19px',
                // width: '220px',
                fontFamily: 'Golos',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '16px'
              }, isArchive() ? {
                background: '#A5A2A1'
              } : {}),
              textStyle: {
                textAlign: 'center'
              }
            }, tsNextWidgetConfig && {
              'data-type': tsNextWidgetConfig.type,
              'data-uid': tsNextWidgetConfig.id,
              className: 'tsnext-widget'
            }))
          }), promos.results && promos.results.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _slug_ref13,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.rU, {
              href: [promos.results[0].url].join('/'),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(picture/* Image */.Ee, {
                image: promos.results[0].image,
                alt: "\u043F\u0440\u043E\u043C\u043E"
              })
            })
          }), eventData.status === events/* activeStatus */.cT && isRanOutOfTickets && (eventData.subscription_confirmed ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_slug_objectSpread(_slug_objectSpread({}, theme.mixins.fonts.golos), {}, {
              display: 'flex',
              flexDirection: 'row',
              gap: 15,
              marginBottom: 10,
              padding: '24px 16px',
              backgroundColor: theme.colors.white,
              color: theme.colors.text,
              height: 'auto',
              alignItems: 'flex-start',
              svg: {
                paddingTop: 5
              }
            }),  true ? "" : 0,  true ? "" : 0),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(check_mark, {
              css: _slug_ref14
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: "\u041C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043C \u0432\u0430\u043C, \u043A\u043E\u0433\u0434\u0430 \u0431\u0438\u043B\u0435\u0442\u044B \u043D\u0430 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443"
            })]
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_slug_objectSpread(_slug_objectSpread({}, theme.mixins.fonts.golos), {}, {
              display: 'flex',
              flexDirection: 'column',
              gap: 15,
              height: 180,
              marginBottom: 10,
              color: theme.colors.white,
              padding: '24px 16px',
              backgroundColor: theme.colors.red
            }),  true ? "" : 0,  true ? "" : 0),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
              children: "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 e-mail, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043B\u0438, \u043A\u043E\u0433\u0434\u0430 \u0431\u0438\u043B\u0435\u0442\u044B \u0441\u043D\u043E\u0432\u0430 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribeForm/* default */.Z, {
              source: "ArchiveSubscription",
              eventId: eventData.id,
              currentCity: currentCity,
              onSuccessSubscribe: onSuccessSubscribe
            })]
          })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: _slug_ref15,
            children: [eventData.service_fee === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: _slug_ref16,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(service_free, {
                css: _slug_ref17
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: "\u0431\u0435\u0437 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u043E\u0433\u043E \u0441\u0431\u043E\u0440\u0430"
              })]
            }), eventData.service_fee && eventData.service_fee > 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: _slug_ref18,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: _slug_ref19,
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(circle, {
                  css: _slug_ref20
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                  css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    fontFamily: 'Montserrat',
                    fontSize: 10,
                    fontWeight: 500,
                    color: theme.colors.red,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  },  true ? "" : 0,  true ? "" : 0),
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                    children: [eventData.service_fee, "%"]
                  })
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: "\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0441\u0431\u043E\u0440"
              })]
            }) : '', ['purchase', 'certificate', 'tsnext_widget'].includes(eventData.type) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: _slug_ref21,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lock, {
                css: _slug_ref22
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: "\u0437\u0430\u0449\u0438\u0442\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
              })]
            }), ['purchase', 'certificate', 'tsnext_widget'].includes(eventData.type) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: _slug_ref23,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bank_card, {
                css: _slug_ref24
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: "\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043A\u0430\u0440\u0442\u043E\u0439 \u043B\u044E\u0431\u043E\u0433\u043E \u0431\u0430\u043D\u043A\u0430"
              })]
            }), (eventData === null || eventData === void 0 ? void 0 : eventData.cancellation_policy) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                display: 'flex',
                gap: 10,
                alignItems: eventData.cancellation_policy === '10_days' ? 'flex-start' : 'center'
              },  true ? "" : 0,  true ? "" : 0),
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cancel, {
                css: _slug_ref25
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: (0,utils_event/* getCancellationPolicyText */.Qw)(eventData.cancellation_policy)
              })]
            }), eventData.type === 'reservation' && eventData.payment_on_spot && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              css: _slug_ref26,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                src: payment_on_spot.src,
                alt: "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
                css: _slug_ref27
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0435 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435"
              })]
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "col-12 col-md-6 push-md-1 col-lg-7 push-lg-1",
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            position: 'relative',
            left: '8.33333333%'
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            left: 0
          }),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _slug_ref28,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareBlock/* ShareBlock */.T, {
              item: eventData
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
              marginBottom: 40
            }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
              '.crop-text': {
                margin: '0 8px 40px 8px'
              }
            }),  true ? "" : 0,  true ? "" : 0),
            id: "actions__description-block",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
              title: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
              description: eventData.description
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: _slug_ref29,
              itemProp: "description",
              dangerouslySetInnerHTML: {
                __html: "".concat(eventData.description.slice(0, 999), "...")
              }
            })]
          }), eventData.block_1_title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _slug_ref30,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
              title: eventData.block_1_title,
              description: (_eventData$block_1_de = eventData.block_1_description_html) !== null && _eventData$block_1_de !== void 0 ? _eventData$block_1_de : eventData.block_1_description
            })
          }), eventData.block_2_title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _slug_ref31,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
              title: eventData.block_2_title,
              description: (_eventData$block_2_de = eventData.block_2_description_html) !== null && _eventData$block_2_de !== void 0 ? _eventData$block_2_de : eventData.block_2_description
            })
          }), (eventData.images.length > 1 || eventData.video_url) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(images_slider/* ImagesSlider */.f, {
            videoInfo: {
              video: eventData.video_url,
              cover: eventData.video_cover
            },
            images: eventData.images,
            onSlideClick: function onSlideClick(index) {
              return setImageModal({
                slide: index,
                visible: true
              });
            }
          }), eventData.condition_title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _slug_ref32,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
              title: eventData.condition_title,
              description: eventData.condition
            })
          }), !!(socials !== null && socials !== void 0 && socials.results.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: _slug_ref33,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collapsable/* AskQuestion */.i7, {
              socials: socials
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonsBlock, {
            eventData: eventData
          }), isShowBuyButton && !eventData.date_unknown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css10 = {
              display: 'none'
            }, (0,defineProperty/* default */.Z)(_css10, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
              display: 'block'
            }), (0,defineProperty/* default */.Z)(_css10, "marginBottom", 0), (0,defineProperty/* default */.Z)(_css10, "position", 'fixed'), (0,defineProperty/* default */.Z)(_css10, "bottom", 0), (0,defineProperty/* default */.Z)(_css10, "left", 0), (0,defineProperty/* default */.Z)(_css10, "right", 0), (0,defineProperty/* default */.Z)(_css10, "backgroundColor", theme.colors.white), (0,defineProperty/* default */.Z)(_css10, "zIndex", 100), (0,defineProperty/* default */.Z)(_css10, "padding", 0), (0,defineProperty/* default */.Z)(_css10, "boxShadow", "0 0 5px rgba(0, 0, 0, 0.2)"), _css10),  true ? "" : 0,  true ? "" : 0),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* BuyButton */.lo, _slug_objectSpread(_slug_objectSpread({
              callback: function callback() {
                return onClickBuyButton();
              },
              disabled: isArchive(),
              full: true,
              subscription_confirmed: eventData.status === events/* activeStatus */.cT && eventData.subscription_confirmed
            }, tsNextWidgetConfig && {
              'data-type': tsNextWidgetConfig.type,
              'data-uid': tsNextWidgetConfig.id,
              className: 'tsnext-widget'
            }), {}, {
              children: [eventData.status === events/* activeStatus */.cT && eventData.subscription_confirmed && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(check_mark, {
                css: _slug_ref34
              }), (0,utils_event/* getBuyButtonText */.A)(eventData, isRanOutOfTickets)]
            }))
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentsBlock/* CommentsBlock */.i, {
              contentType: "events.event",
              eventId: eventData.id,
              currentCity: currentCity
            })
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css11 = {
          '.actions__item': {
            width: 320
          }
        }, (0,defineProperty/* default */.Z)(_css11, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          '.actions__item': {
            width: 270
          }
        }), (0,defineProperty/* default */.Z)(_css11, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          padding: '0 8px',
          '.actions__item': {
            maxWidth: '77%',
            width: '100%'
          }
        }), _css11),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimilarEventsBlock, {
          eventData: eventData,
          currentCity: currentCity
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(viewed_viewed/* Viewed */.E, {
          title: "\u0412\u044B \u0441\u043C\u043E\u0442\u0440\u0435\u043B\u0438",
          viewed: viewed
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 16,
          marginBottom: '4rem',
          marginTop: '2rem'
        }, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
          gridTemplateColumns: '1fr',
          padding: '0 8px'
        }),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subscription/* Subscription */.w, {
          currentCity: currentCity
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileApps/* MobileApps */._, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpButton/* UpButton */.e, {
        elementId: "actions__description-block",
        screenCount: 1.5
      }), !!imageModal.visible && (!!((_eventData$images = eventData.images) !== null && _eventData$images !== void 0 && _eventData$images.length) || !!eventData.video_url) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PictureModal/* PictureModal */.U, {
        videoInfo: {
          video: eventData.video_url,
          cover: eventData.video_cover
        },
        images: eventData.images.slice(1),
        imageModal: imageModal,
        scrollY: window.scrollY,
        setVisible: setImageModal
      })]
    })]
  });
}

var __N_SSP = true;
function Page(_ref35) {
  var currentCity = _ref35.currentCity,
      cities = _ref35.cities,
      eventData = _ref35.eventData,
      footerProps = _ref35.footerProps,
      promos = _ref35.promos,
      configOfSite = _ref35.configOfSite,
      categoriesForHeader = _ref35.categoriesForHeader,
      gorbiletRekomenduet = _ref35.gorbiletRekomenduet;
  var gbReccomendLink = gorbiletRekomenduet.slug ? ['', currentCity.url, 'compilations', gorbiletRekomenduet.slug, ''].join('/') : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* Layout */.A, {
    footerProps: footerProps,
    currentCity: currentCity,
    cities: cities,
    categoriesForHeader: categoriesForHeader,
    seoTitle: eventData.seo_title && eventData.seo_title !== '' ? eventData.seo_title : eventData.title,
    seoDescription: eventData.seo_description && eventData.seo_description !== '' ? eventData.seo_description : '',
    canonicalLink: "".concat(apiUrl/* GB_DOMAIN */.pJ, "/").concat(currentCity.url, "/actions/").concat(eventData.slug, "/"),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageComponent, {
      configOfSite: configOfSite,
      currentCity: currentCity,
      eventData: eventData,
      promos: promos,
      gbReccomendLink: gbReccomendLink,
      socials: footerProps.socials
    })
  });
}

/***/ }),

/***/ 8149:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/actions/[slug]",
      function () {
        return __webpack_require__(5685);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2189)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4838,5924,5675,8384,4751,3189,2068,902,9013,7601,5585,4455,5435,4052,5705,4553,2863,5546,8842,261,9553,9774,2888,179], function() { return __webpack_exec__(8149); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);